/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import Moment from 'moment';
import { Table, Column, Cell } from 'fixed-data-table';
import { browserHistory } from 'react-router';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
// import { DiscussionCount, OnlineRepairDatePicker } from './OnlineRepairPs';
// import RepairPdfContentPs from './RepairPdfContentPs';
import Select from 'react-virtualized-select';
import DayPicker from '../../../commonComponents/DayPicker';
import DiscussionModal from '../workLog/DiscussionModal';
import DiscussionCell from '../workLog/DiscussionCell';
import { SortHeaderCell } from '../../../commonComponents/DataTable/DataTablePs';
import Uploading from '../../../commonComponents/DataLoading';
// import { ExportBtn } from '../report/ReportPs';

import {
	Row, Col, Modal,
	Button, Glyphicon,
	FormGroup,
	ControlLabel, FormControl
} from 'react-bootstrap';


// import { DataListWrapper, SortTypes, SortHeaderCell, TextCell, NewsTypeCell, TimeWithoutHHmmssCell } from '../../../commonComponents/DataTable/DataTablePs';
// import custJqAjax from '../../../commonJS/custJqAjax';

const DropDownMenu = props => {
	const { languageData, languageCode } = window.myConsts;

	return (
		<Col sm={props.sm}>
			<FormGroup validationState={props.validationState} style={{ position: 'relative' }}>
				<ControlLabel>{props.required ? <span style={{ color: 'red' }}>* </span> : ''}<span style={{ fontWeight: 'bold' }}>{props.label}</span></ControlLabel>
				<div className={'validation-state-' + props.validationState}>
					<Select
						inputProps={{ id: props.id }}
						multi={props.multi}
						openOnFocus={true}
						disabled={props.disabled}
						value={props.value}
						valueKey={props.valueKey}
						labelKey={props.labelKey}
						matchProp='label'
						clearable={props.clearable || false}
						placeholder={
							!props.disabled
								? languageData['528'][languageCode]
								: ''
						}
						noResultsText={languageData['448'][languageCode]}
						onChange={selection => { props.onChange(selection, props.stateName); }}
						options={props.options}
						filterOptions={props.filterOptions} />
				</div>
			</FormGroup>
		</Col>
	)
};

const CloudSearchModalUd = props => {
	const { languageData, languageCode } = window.myConsts;

	const { origProps, origState, onChangeData, filterOptions, onGoSearch } = props,
		{ basic_data, assign_data, status_data, cloudSearchContent } = origState;

	let disabledStatus = false;
	if (
		cloudSearchContent.status.length <= 0 &&
		!cloudSearchContent.request_date_start &&
		!cloudSearchContent.request_date_end &&
		!cloudSearchContent.start_date_star &&
		!cloudSearchContent.start_date_end &&
		!cloudSearchContent.repair_date_start &&
		!cloudSearchContent.repair_date_end &&
		cloudSearchContent.service_type_id.length <= 0 &&
		cloudSearchContent.fix_user_id.length <= 0 &&
		!cloudSearchContent.contact_name &&
		!cloudSearchContent.serial_number &&
		!cloudSearchContent.repair_id
	) disabledStatus = true;

	return (
		<Modal id='modal-product' onHide={props.closeModal} show={true} keyboard={false} backdrop='static' bsSize='large'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>
						{'雲端搜尋'}
					</span>
					<Button onClick={props.closeModal} className='funBtn'>
						{languageData['452'][languageCode]}
					</Button>
					<Button onClick={onGoSearch} className='funBtn' disabled={disabledStatus}>
						{languageData['78'][languageCode]}
					</Button>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<DropDownMenu
						sm={4}
						label={'狀態'}
						multi={true}
						// disabled={!enableEdit}
						// stateName='assign'
						value={cloudSearchContent.status}
						valueKey='id'
						labelKey='name'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].id);
							}

							cloudSearchContent.status = arr;

							onChangeData(cloudSearchContent);
						}}
						options={status_data}
						filterOptions={filterOptions} />
					<DropDownMenu
						sm={4}
						label={'類別'}
						multi={true}
						// disabled={!enableEdit}
						// stateName='assign'
						value={cloudSearchContent.service_type_id}
						valueKey='key'
						labelKey='name'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].key);
							}

							cloudSearchContent.service_type_id = arr;

							onChangeData(cloudSearchContent);
						}}
						options={_.filter(basic_data, { group_name: 'repair_service_type_id' })}
						filterOptions={filterOptions} />
					<DropDownMenu
						sm={4}
						label={'負責工程師'}
						multi={true}
						// disabled={!enableEdit}
						// stateName='assign'
						value={cloudSearchContent.fix_user_id}
						valueKey='user_id'
						labelKey='user_name'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].user_id);
							}

							cloudSearchContent.fix_user_id = arr;

							onChangeData(cloudSearchContent);
						}}
						options={assign_data}
						filterOptions={filterOptions} />
					<Col sm={4}>
						<FormGroup controlId='contactName'>
							<ControlLabel style={{ fontWeight: 'bold' }}>客戶聯絡人</ControlLabel>
							<FormControl
								// disabled={!enableEdit}
								type='text'
								onChange={(e) => {
									const str = e.currentTarget.value;
									cloudSearchContent.contact_name = str;

									onChangeData(cloudSearchContent);
								}}
								value={cloudSearchContent.contact_name} />
						</FormGroup>
					</Col>
					<Col sm={4}>
						<FormGroup controlId='serialNumber'>
							<ControlLabel style={{ fontWeight: 'bold' }}>儀器序號</ControlLabel>
							<FormControl
								// disabled={!enableEdit}
								type='text'
								onChange={(e) => {
									const str = e.currentTarget.value;
									cloudSearchContent.serial_number = str;

									onChangeData(cloudSearchContent);
								}}
								value={cloudSearchContent.serial_number} />
						</FormGroup>
					</Col>
					<Col sm={4}>
						<FormGroup controlId='repairId'>
							<ControlLabel style={{ fontWeight: 'bold' }}>服務單編號</ControlLabel>
							<FormControl
								// disabled={!enableEdit}
								type='text'
								onChange={(e) => {
									const str = e.currentTarget.value;
									cloudSearchContent.repair_id = str;

									onChangeData(cloudSearchContent);
								}}
								value={cloudSearchContent.repair_id} />
						</FormGroup>
					</Col>
					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'填單日期開始'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.request_date_start = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.request_date_start} />
					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'填單日期結束'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.request_date_end = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.request_date_end} />

					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'安排/維修日期開始'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.start_date_star = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.start_date_star} />
					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'安排/維修日期結束'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.start_date_end = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.start_date_end} />

					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'離開日期開始'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.repair_date_start = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.repair_date_start} />
					<DayPicker
						labelFontWeight='bold'
						sm={3}
						outerLabel={'離開日期結束'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.repair_date_end = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.repair_date_end} />
				</Row>
			</Modal.Body>
		</Modal>
	)
};

export default class OnlineRepairServiceDataTable extends React.Component {
	constructor(props) {

		super(props);

		this.handlers = {
			onChangeCloudSearch: (type, data) => {
				switch (type) {
					case 'search':
						const { cloudSearchContent } = this.state,
							cloudSearchStr =
								`${cloudSearchContent.status && cloudSearchContent.status.length > 0 ? 'status=' + cloudSearchContent.status.join() + '&' : ''}${cloudSearchContent.request_date_start ? 'request_date_start=' + Moment(cloudSearchContent.request_date_start).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.request_date_end ? 'request_date_end=' + Moment(cloudSearchContent.request_date_end).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.start_date_star ? 'start_date_star=' + Moment(cloudSearchContent.start_date_star).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.start_date_end ? 'start_date_end=' + Moment(cloudSearchContent.start_date_end).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.repair_date_start ? 'repair_date_start=' + Moment(cloudSearchContent.repair_date_start).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.repair_date_end ? 'repair_date_end=' + Moment(cloudSearchContent.repair_date_end).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.service_type_id && cloudSearchContent.service_type_id.length > 0 ? 'service_type_id=' + cloudSearchContent.service_type_id.join() + '&' : ''}${cloudSearchContent.fix_user_id && cloudSearchContent.fix_user_id.length > 0 ? 'fix_user_id=' + cloudSearchContent.fix_user_id.join() + '&' : ''}${cloudSearchContent.contact_name ? 'contact_name=' + cloudSearchContent.contact_name + '&' : ''}${cloudSearchContent.serial_number ? 'serial_number=' + cloudSearchContent.serial_number + '&' : ''}${cloudSearchContent.repair_id ? 'repair_id=' + cloudSearchContent.repair_id + '&' : ''}`;

						this.setState({ showCloudSearchModal: false }, () => {
							if (cloudSearchStr) {
								this.setState({ cloudSearchStr, is_loading: true, is_all_data_loaded: false, is_merge: false }, () => {
									// this.props.oldFuncExtraProps.parentStateHandler({ states: 'showCloudSearchForm', newValues: true });
									this.loadTableData(cloudSearchStr);
								})
							}
						})
						break;
					case 'change':
						this.setState({ cloudSearchContent: data })
						break;
					case 'close':
						this.setState({ showCloudSearchModal: false }, () => {
							// this.props.oldFuncExtraProps.parentStateHandler({ states: 'showCloudSearchForm', newValues: false });
						})
						break;

					default:
				}
			},
			onTableScroll: (scrollX, scrollY) => {
				const { systemEnvironment } = this.props,
					itemEndCount = systemEnvironment.End_Count * 1 || 100,
					{ all_data, start_count, total_count, cloudSearchStr } = this.state,
					tableHeight = $('.public_Scrollbar_main').height(),
					position = $('.fixedDataTableLayout_rowsContainer>div:nth-child(3)').css('transform').split(/\w+\(|\);?/)[1].split(/,\s?/g),
					tagHeight = all_data.length * 50 - 50 - tableHeight;

				if (tagHeight === Math.abs(position[5])) {
					// const newEndCount = all_data.length + itemEndCount;
					const newStartCount = start_count + itemEndCount,
						newEndCount = newStartCount + 99;

					if (newStartCount < total_count) {
						this.setState({ is_loading: true, is_all_data_loaded: false, is_merge: false }, () => {
							this.loadTableData(cloudSearchStr, newStartCount, newEndCount);
						})
					}
				}
			},
			onDiscussionsClick: (e, rowIndex, sortedData) => {
				e.stopPropagation();
				let id = sortedData.getObjectAt(rowIndex).repair_id;
				this.setState({
					selectedItemId: id,
					selectedRowIndex: rowIndex,
					showDiscussionModal: true
				});
			},
			onCloseModal: (...params) => {
				// for customer tab
				this.setState({
					selectedRowIndex: '',
					selectedItemId: ''
				});

				props.closeModal(...params);
			}
		};

		this.state = {
			showCloudSearchModal: false,
			cloudSearchContent:
			{
				status: [],
				request_date_start: null,
				request_date_end: null,
				start_date_star: null,
				start_date_end: null,
				repair_date_start: null,
				repair_date_end: null,
				service_type_id: [],
				fix_user_id: [],
				contact_name: '',
				serial_number: '',
				repair_id: ''
			},
			cloudSearchStr: '',
			selectedItemId: '',
			selectedRowIndex: '',
			showDiscussionModal: false,
			onExportPDF: false,
			arrCheckedId: [],
			arrIsCheck: null,
			is_loading: true,
			all_data: [],
			// overItem: false,
			start_count: 1,
			total_count: 0,
			is_all_data_loaded: false,
			status_data: [],
			// form_type_data: [],
			area_data: [],
			// contract_data: [],
			company_data: [],
			factory_data: [],
			// form_source_data: [],
			repair_man_data: [],
			// product_data: [],
			user_data: [],
			// service_type_data: [],
			assign_data: [],
			// question_data: [],
			// responsibility_data: [],
			parts_data: [],
			// currency_data: [],
			service_result_data: [],
			basic_data: [],
			brand_data: [],
			is_brand_data_loaded: false,
			is_basic_data_loaded: false,
			is_user_data_loaded: false,
			is_status_data_loaded: false,
			// is_form_type_data_loaded: false,
			is_area_data_loaded: false,
			// is_contract_data_loaded: false,
			is_company_data_loaded: false,
			is_factory_data_loaded: false,
			// is_form_source_data_loaded: false,
			// is_product_data_loaded: false,
			is_man_data_loaded: false,
			// is_service_type_data_loaded: false,
			is_assign_data_loaded: false,
			// is_question_data_loaded: false,
			// is_responsibility_data_loaded: false,
			is_parts_data_loaded: false,
			// is_currency_data_loaded: false,
			is_service_result_data_loaded: false,
			is_merge: false,
			start_date: '2010-01-01',
			end_date: '2050-01-01',
			width: 1000,
			table_sort: {},
		}

		this.onClickExport = this.onClickExport.bind(this);
		this.loadTableData = this.loadTableData.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.reload = this.reload.bind(this);
		this.onSortChange = this.onSortChange.bind(this);

		this.closeDiscussionModal = () => {
			this.setState({ showDiscussionModal: false });
		};

		this.parentStateHandler = ({ states, newValues }) => {
			parentStateHandler({ states, newValues, parentThis: this });
		};

		this.onExportChecked = (e, rowIndex) => {
			e.stopPropagation();

			// 防止點擊匯出PDF鈕之後，選擇'是否'之前再去改變勾選狀態
			if ($('#popover-trigger-click')[0]) {
				return;
			}

			// 以slice複製產生新陣列
			const arrCheckedId = this.state.arrCheckedId.slice(),
				arrIsCheck = this.state.arrIsCheck.slice();

			// 原本狀態為打勾時，移除id
			if (arrIsCheck[rowIndex]) {
				const ind = arrCheckedId.indexOf(this.state.all_data[rowIndex].id);
				arrCheckedId.splice(ind, 1);
				// 原本未打勾，新增id
			} else {
				arrCheckedId.push(this.state.all_data[rowIndex].id);
			}

			arrIsCheck[rowIndex] = !arrIsCheck[rowIndex];

			this.setState({ arrIsCheck, arrCheckedId });
		};

		this.onExportClick = (withPhoto) => {
			// 是否處於客戶tab
			if (this.props.onTabTableRowClick) {
				// 產生modal
				this.props.onTabTableRowClick('pdfBacthExport');
				// 用以在客戶tab下判斷pdf批次匯出觸發

				this.setState({ selectedItemId: 'pdfBacthExport' + (withPhoto ? '' : '-withoutphoto') });
			} else {
				let routeHead = '/salesky/online-repair-service/pdf-export';
				const route = routeHead + (withPhoto ? '' : '-withoutphoto');
				browserHistory.push(route);
			}
			this.setState({ onExportPDF: true });
		};
	}

	componentDidMount() {
		this.loadTableData();
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Status_Lang_Get.php', 'status_data', 'is_status_data_loaded');
		this.loadOtherData('/api/M_ServiceSky_Repair_Sky_Status_Get.php', 'status_data', 'is_status_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Type_Lang_Get.php', 'form_type_data', 'is_form_type_data_loaded');
		// 負責工程師、CC人員
		this.loadOtherData('/api/W_ManageAccount_Get.php', 'user_data', 'is_user_data_loaded');
		this.loadOtherData('/api/M_Basic_Group_Data_Get.php', 'basic_data', 'is_basic_data_loaded');
		// 廠牌、生產線
		this.loadOtherData('/api/M_Brand_Ref_Get.php', 'brand_data', 'is_brand_data_loaded');

		this.loadOtherData('/api/W_ServiceSky_RepairSky_Area_Type_Lang_Get.php', 'area_data', 'is_area_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Warranty_Type_Lang_Get.php', 'contract_data', 'is_contract_data_loaded');
		this.loadOtherData('/api/W_SaleSky_Company_Get.php', 'company_data', 'is_company_data_loaded');
		this.loadOtherData('/api/W_ServiceSky_System_Customer_Factory_Get.php', 'factory_data', 'is_factory_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_From_Type_Lang_Get.php', 'form_source_data', 'is_form_source_data_loaded');
		// this.loadOtherData('/api/M_SaleSky_Product_Get.php', 'product_data', 'is_product_data_loaded');

		//報修人員
		this.loadOtherData('/api/M_SaleSky_Users.php', 'repair_man_data', 'is_man_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Service_Type_Lang_Get.php', 'service_type_data', 'is_service_type_data_loaded');
		this.loadOtherData('/api/M_ServiceSky_Fix_User_Get.php', 'assign_data', 'is_assign_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Issue_Type_Lang_Get.php', 'question_data', 'is_question_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Judge_Type_Lang_Get.php', 'responsibility_data', 'is_responsibility_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_Part_List_Get.php', 'parts_data', 'is_parts_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Currency_Lang_Get.php', 'currency_data', 'is_currency_data_loaded');
		this.loadOtherData('/api/M_ServiceSky_RepairSky_Satisfaction_Type_Lang_Get.php', 'service_result_data', 'is_service_result_data_loaded');
		// this.loadOtherData('/api/W_ServiceSky_RepairSky_Satisfaction_Type_Lang_Get.php', 'service_result_data', 'is_service_result_data_loaded');
	}

	componentWillUpdate(nextProps, nextState) {
		// 顯示批量匯出PDF介面時初始化紀錄勾選狀態arr
		if (
			nextProps.oldFuncExtraProps.showBatchExportUI &&
			!nextState.arrIsCheck &&
			nextState.all_data.length
		) {

			const arrIsCheck = [];
			for (let i = nextState.all_data.length - 1; i >= 0; i--) {
				arrIsCheck.push(false);
			}

			this.setState({ arrIsCheck });

		}

		// 重置
		if (nextProps.oldFuncExtraProps.showBatchExportUI !== this.props.oldFuncExtraProps.showBatchExportUI) {
			if (nextState.arrIsCheck) {
				const arrIsCheck = nextState.arrIsCheck.map((item, ind) => {
					return false;
				});
				this.setState({ arrIsCheck });
			}
		}

		// 資料改變時重置(搜尋更新、新增項目)
		if (nextProps.oldFuncExtraProps.showBatchExportUI &&
			nextProps.searchResults._data !== this.props.searchResults._data &&
			nextState.arrIsCheck) {

			const arrIsCheck = nextState.arrIsCheck.map(() => false);
			this.setState({ arrCheckedId: [], arrIsCheck });
		}

	}

	componentWillReceiveProps(nextProps) {
		const { all_data, is_merge } = this.state
		let search_data = all_data
		if (nextProps.searchResults._data) {

			if (this.props.searchResults._data !== nextProps.searchResults._data) {
				// sort_data = _.orderBy( nextProps.searchResults._data, ['request_date'], ['desc'])
				search_data = nextProps.searchResults._data
			}
		}
		else if (nextProps.searchResults._data === undefined && is_merge === true) {

			// sort_data = _.orderBy( nextProps.filteredDataList._data, ['request_date'], ['desc'])
			search_data = nextProps.filteredDataList._data

		}

		// 切換批次匯出pdf ui時清空勾選內容
		if (nextProps.oldFuncExtraProps.showBatchExportUI !== this.props.oldFuncExtraProps.showBatchExportUI) {
			this.setState({ arrCheckedId: [] });
		}


		// qmo這裡無進一步判斷的setState，變成只要任何一個props更新，都會觸發render兩次
		this.setState({ all_data: search_data }, this.onSortChange);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			all_data, is_all_data_loaded,
			status_data, is_status_data_loaded,
			is_merge, is_loading,
			start_date, end_date,
			area_data, is_area_data_loaded,
			// contract_data, is_contract_data_loaded,
			// question_data, is_question_data_loaded
		} = this.state;

		if (is_merge === true && is_loading === true) {
			this.setState({ is_loading: false })
		} else if (
			is_all_data_loaded &&
			is_status_data_loaded &&
			is_area_data_loaded &&
			// is_contract_data_loaded &&
			is_merge === false
		) {
			let merge_data =
				all_data
					.map((x, y) => {
						// 狀態
						let find_data = _.find(status_data, { id: x.status });
						if (find_data !== undefined) {
							x.status_name = find_data.name
							x.status_color = find_data.color_code
						} else {
							x.status_name = '無'
							x.status_color = '#000'
						}

						// 地區/機型
						let find_area_data = _.find(area_data, { area_type_id: x.area_type_id });
						x.area_type_name = find_area_data === undefined ? '無' : find_area_data.area_type_name

						// 保固/維修合約
						// let find_warranty_data = _.find(contract_data, { warranty_type_id: x.warranty_type_id });
						// x.warranty_type_name = find_warranty_data === undefined ? '無' : find_warranty_data.warranty_type_name

						// 原因判斷
						// let find_issue_data = _.find(question_data, { issue_type_id: x.issue_type_id })
						// x.issue_type_name = find_issue_data === undefined ? '無' : find_issue_data.issue_type_name_test

						return x;
					})

			let defaultSortIndexes = [];
			let size = merge_data.length;
			for (let i = 0; i < size; i++) {
				defaultSortIndexes.push(i);
			}

			const dataListWrapper = new DataListWrapper(defaultSortIndexes, merge_data);

			if (this.props.router) {
				this.props.returnDataListToDashboardFunc(dataListWrapper, 'online-repair-service');
			} else {
				this.props.parentStateHandler({ states: 'filteredDataList', newValues: dataListWrapper });
			}

			this.setState({ all_data: merge_data, is_merge: true })
		}

		// crud之後更新搜尋結果以及回復排序
		if (prevProps.filteredDataList._data !== this.props.filteredDataList._data) {
			// 客戶資訊時不需更新搜尋結果
			if (!this.props.noSearchUpdate) {
				this.props.updateSearchResults();
			}

			this.onSortChange();
		}

		if (
			this.props.oldFuncExtraProps.showCloudSearchForm !== prevProps.oldFuncExtraProps.showCloudSearchForm
		) {
			if (this.props.oldFuncExtraProps.showCloudSearchForm) this.setState({ showCloudSearchModal: true })
			else if (!this.props.oldFuncExtraProps.showCloudSearchForm) {
				this.setState({ cloudSearchStr: '', is_loading: true, is_all_data_loaded: false, is_merge: false }, () => {
					this.loadTableData();
				})
			}
		}
	}

	onClickExport() {
		let dataListWorkLog;

		// 不需要的欄位放這裡
		let keysToDelete;

		dataListWorkLog = this.state.all_data;
		keysToDelete = ['area_type_id', 'company_id', 'contact_id', 'content', 'department', 'ext_number', 'factory_id', 'fix_user_id', 'from_id', 'id', 'issue_images', 'issue_pdfs', 'issue_videos', 'job_title', 'model_id', 'part_id', 'parts_list', 'price', 'product_type', 'product_type_id', 'qa_description', 'repair_discuss_count', 'replacement_parts', 'request_user_id', 'return_status', 'shipping_date', 'shipping_rate', 'shipping_record_id', 'shpping_description', 'signature', 'signature_images', 'signature_pdfs', 'signature_videos', 'signatureapprover_images', 'signatureapprover_pdfs', 'satisfaction_id', 'signatureapprover_videos', 'signaturemanager_images', 'signaturemanager_pdfs', 'type_id', 'issue_type', 'signaturemanager_videos', 'solution_images', 'solution_pdfs', 'solution_videos', 'source', 'start_date', 'status', 'status_color', 'tax_number', 'used_status', 'warranty_expire_date', 'warranty_type_id', 'currency', 'judge_id'];

		let dataListRomovedByKey = [];//拿掉部分key的objects
		for (let i = 0; i < dataListWorkLog.length; i++) {
			let newObj = this.removeByKey(dataListWorkLog[i], keysToDelete);
			dataListRomovedByKey.push(newObj);
		}

		let arrayOfArrays = this.objectToArray(dataListRomovedByKey);//把objects依照表頭順序轉成array
		//表頭, 中文
		let thead, fileName;
		fileName = 'repair_service.csv';
		thead = ['表單建立者', '表單狀態', '報修人員', '產品', '產品序號', '區域', '維修單編號', '工令號碼', '報修日期', '公司', '廠區', '地址', '聯絡人', '聯絡電話', '行動電話', '電子郵件', '訂單編號', '表單類型', '服務日期', '零件預備', '報修內容', '原因判斷', '對策及處理方式', '備註', '服務人員', '協同人員', '到達日期', '離開日期', '維修內容', '服務結果確認', '幣別', '車資', '工時費用', '服務基本(技術)費', '折扣', '合計', '稅', '總計費用', '發票編號', '發票抬頭', '備註', '有無費用', '責任歸屬', '再發防止', '對策成果(績效追蹤)', '主管評核', '總經理核示'];

		arrayOfArrays.unshift(thead);//把表頭放進陣列第一個

		this.exportToCsv(fileName, arrayOfArrays);
	}
	removeByKey(myObj, keysToDelete) {//把數個key從一個object移除的工具
		let newObj = myObj;

		for (let i = 0; i < keysToDelete.length; i++) {
			newObj = removeKeysInOneObject(newObj, i);
		}

		function removeKeysInOneObject(newObj, i) {
			return Object.keys(newObj).filter(key => key !== keysToDelete[i]).reduce((result, current) => {
				result[current] = newObj[current];
				return result;
			}, {});
		}
		return newObj;
	}
	objectToArray(arrayOfObjects) {//將數個objects轉成數個arrays
		let arrayOfArrays = [];
		for (let i = 0; i < arrayOfObjects.length; i++) {
			//欄位順序, 同onClickExport()的thead, 若要更動欄位順序或增減欄位, 兩個都要改
			let arrSchema;
			const reportType = this.props.reportType;
			arrSchema = ['create_user', 'status_name', 'request_user_name', 'model_name', 'serial_number', 'area_type_name', 'repair_id', 'job_number', 'request_date', 'company_name', 'factory_name', 'address', 'contact_name', 'work_phone', 'cell_phone', 'email', 'order_number', 'type_name', 'repair_date', 'part_description', 'issue_description', 'issue_type_name', 'decision_description', 'remark', 'fix_user_name', 'teamworker', 'arrival_time', 'leave_time', 'solution_description', 'satisfaction_name', 'currency_name', 'car_cost', 'work_cost', 'tech_cost', 'discount', 'sub_total_cost', 'tax', 'total_cost', 'invoice_number', 'invoice_title', 'cost_description', 'warranty_type_name', 'judge_name', 'prevent_description', 'service_type_id', 'supervisor_review', 'gm_description'];

			let arrResult = this.orderedValues(arrSchema, arrayOfObjects[i]);
			arrayOfArrays.push(arrResult);
		}
		return arrayOfArrays;
	}
	orderedValues(arrSchema, obj) {//一個object轉成array時, 依照arrSchema的順序排列的工具
		var arrResult = [];
		for (var i = 0; i < arrSchema.length; i++)
			arrResult[i] = obj[arrSchema[i]];

		return arrResult;
	}
	exportToCsv(filename, rows) {
		var processRow = function (row) {
			var finalVal = '';
			for (var j = 0; j < row.length; j++) {
				var innerValue = row[j] === null ? '' : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				};
				var result = innerValue.replace(/"/g, '""');
				if (result.search(/("|,|\n)/g) >= 0)
					result = '"' + result + '"';
				if (j > 0)
					finalVal += ',';
				finalVal += result;
			}
			return finalVal + '\n';
		};

		var csvFile = '';
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var BOM = '\uFEFF';//讓MS Excel能讀取utf-8
		csvFile = BOM + csvFile;
		var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8' });
		if (navigator.msSaveBlob) { // IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			var link = document.createElement('a');
			if (link.download !== undefined) { // feature detection
				// Browsers that support HTML5 download attribute
				var url = URL.createObjectURL(blob);
				link.setAttribute('href', url);
				link.setAttribute('download', filename);
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}

	loadTableData(cloudSearchStr = '', start_count = 1, end_count) {
		const { systemEnvironment } = this.props.propsPackageFromSkyFamily;

		let newEndCount =
			systemEnvironment &&
				systemEnvironment.End_Count
				? systemEnvironment.End_Count * 1
				: 100

		let api;
		// 客戶tab的情況下改為指定客戶id的api
		// if (!this.props.params) api = `W_ServiceSky_RepairSky_Get.php?company_id=${this.props.company_id}`;
		// else api = 'W_ServiceSky_RepairSky_Get.php';
		if (!this.props.params) api = `/api/M_ServiceSky_RepairSky_Search_Get.php?company_id=${this.props.company_id}&start_count=${start_count}&end_count=${end_count || newEndCount}`;
		else api = `/api/M_ServiceSky_RepairSky_Search_Get.php?${cloudSearchStr}start_count=${start_count}&end_count=${end_count || newEndCount}`;

		$.ajax({
			type: 'get',
			url: api,
			success: res => {
				let data, total_count = 0;
				if (location.hostname === 'localhost') {
					data = [
						{
							"id": "1410",
							"status": "0",
							"repair_id": "001279",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-06-06 16:59:29",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "1",
							"company_name": "中央研究院　",
							"contact_id": "13445",
							"contact_name": "伍淑琬  小姐",
							"department": "",
							"work_phone": "02-2787-1306",
							"cell_phone": "",
							"email": "misia@gate.sinica.edu.tw",
							"address": "",
							"customer_id": "AAA00A00",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "我",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "基因體中心／採購人員",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "123177",
									"part_name": "XFOV-24 Wide Angle Lens Attachment",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "L202108001",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1409",
							"status": "0",
							"repair_id": "001278",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-05-25 08:36:37",
							"request_user_id": "50",
							"request_user_name": "戴自勇",
							"company_id": "3839",
							"company_name": "柏仁醫院 實驗室",
							"contact_id": "27103",
							"contact_name": "龔秀雯 組長",
							"department": "",
							"work_phone": "07-5508888#1108,#3139",
							"cell_phone": "",
							"email": "karen0213@kimo.com",
							"address": "高雄市左營區博愛二路350號",
							"customer_id": "ZLA00A11",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "我",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "2022-05-26 17:23:17",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "急件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "W202205003",
							"parts_list": [
								{
									"part_id": "120-042-201",
									"part_name": "MS Separation columns 1pc",
									"amount": "2",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								},
								{
									"part_id": "120-042-901",
									"part_name": "LD separation columns 1pc",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "L202105069",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1408",
							"status": "0",
							"repair_id": "001277",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "7",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-05-11 09:32:16",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "3191",
							"company_name": "長庚醫療財團法人 高雄長庚紀念醫院 醫學研究部 第12實驗室",
							"contact_id": "24532",
							"contact_name": "王玲 醫師/曾譯瑩 小姐",
							"department": "",
							"work_phone": "07-7317123#8848",
							"cell_phone": "",
							"email": "qqjoday@hotmail.com",
							"address": "高雄市鳥松區大埤路123號",
							"customer_id": "HAL15B03",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "，",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "王玲 醫師",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "W202205001",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "10",
							"status": "2",
							"repair_id": "000010",
							"type_id": "0",
							"job_number": "0",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "0",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "0",
							"start_date": "2020-08-18 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "0",
							"invoice_number": "0",
							"invoice_title": "0",
							"satisfaction_id": "0",
							"repair_discuss_count": "2",
							"request_date": "2021-01-03 10:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "1902",
							"company_name": "國立成功大學    醫學系寄生蟲學科",
							"contact_id": "20071",
							"contact_name": "林威辰 老師/黃建銘 先生",
							"department": "",
							"work_phone": "06-2353535 #5587 or #5583",
							"cell_phone": "",
							"email": "et10005@hotmail.com",
							"address": "台南市大學路1號",
							"customer_id": "EAK00I01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "0",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "0",
							"issue_type": "0",
							"issue_description": "0",
							"fix_user_id": "1,2",
							"fix_user_name": "測試帳號一,測試使用者",
							"repair_date": "2020-08-18 10:00:00",
							"content": "",
							"job_title": "",
							"shipping_date": "0000-00-00 00:00:00",
							"warranty_expire_date": "0000-00-00 00:00:00",
							"solution_description": "0",
							"replacement_parts": "0",
							"return_status": "0",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "0",
							"arrival_time": "0000-00-00 00:00:00",
							"leave_time": "0000-00-00 00:00:00",
							"create_user": "李欣儒",
							"used_status": "0",
							"ext_number": "0",
							"supervisor_review": "0",
							"expect_date": "0000-00-00 00:00:00",
							"repair_department": "0",
							"repair_priority": "0",
							"company_owner": "0",
							"location": "0",
							"brand": "0",
							"product_line": "0",
							"problem": "0",
							"repair_result": "0",
							"cost_type": "0",
							"message": "0",
							"company_sname": "0",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "p1",
									"part_name": "part_name_test1",
									"amount": "1000",
									"unit_price": "10",
									"subtotal": "100000",
									"part_spec": "part_name_test1",
									"remark": "part_name_test1"
								},
								{
									"part_id": "p2",
									"part_name": "part_name_test2",
									"amount": "200",
									"unit_price": "20",
									"subtotal": "4000",
									"part_spec": "part_name_test2",
									"remark": "part_name_test2"
								}
							],
							"before_doc_id_list": "L201806002",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1407",
							"status": "4",
							"repair_id": "001276",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2022-04-20 18:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2022-04-11 00:00:00",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "476",
							"company_name": "國家衛生研究院    群體健康研究所 精神組",
							"contact_id": "15485",
							"contact_name": "王淑麗 老師/陳曉妍 小姐",
							"department": "",
							"work_phone": "037-246166#36542",
							"cell_phone": "",
							"email": "",
							"address": "苗栗縣竹南鎮科研路35號",
							"customer_id": "BDD00P02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "JuLI",
							"shipping_record_id": "",
							"serial_number": "SCG041402-011",
							"machine_model": "JuLI-FL",
							"issue_type": "",
							"issue_description": "test",
							"fix_user_id": "29",
							"fix_user_name": "林映均",
							"repair_date": "2022-04-20 18:00:00",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "我",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-04-20 00:00:00",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "劉玉麗 老師",
							"location": "",
							"brand": "NanoEntek",
							"product_line": "NanoEntek",
							"problem": "我",
							"repair_result": "我",
							"cost_type": "Y-依發票",
							"message": "",
							"company_sname": "劉玉麗 老師,劉玉麗 老師/方秋萍 小姐",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1406",
							"status": "1",
							"repair_id": "001275",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "11",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-04-11 14:51:36",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "476",
							"company_name": "國家衛生研究院    群體健康研究所 精神組",
							"contact_id": "15484",
							"contact_name": "劉玉麗 老師/方秋萍 小姐",
							"department": "",
							"work_phone": "037-246166#36721",
							"cell_phone": "",
							"email": "eikon@nhri.orgtw",
							"address": "苗栗縣竹南鎮科研路35號",
							"customer_id": "BDD00P02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "JuLI",
							"shipping_record_id": "",
							"serial_number": "SCG041402-011",
							"machine_model": "JuLI-FL",
							"issue_type": "",
							"issue_description": "test",
							"fix_user_id": "29",
							"fix_user_name": "林映均",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "劉玉麗 老師",
							"location": "",
							"brand": "NanoEntek",
							"product_line": "NanoEntek",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "劉玉麗 老師/方秋萍 小姐,",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1",
							"status": "3",
							"repair_id": "000001",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2020-11-16 15:00:07",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "2",
							"request_date": "2020-11-05 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "840",
							"company_name": "國立台灣大學 動物科學技術所",
							"contact_id": "16561",
							"contact_name": "吳信志 老師/陳奕臣 先生",
							"department": "",
							"work_phone": "0983-385583",
							"cell_phone": "",
							"email": "d02642001@ntu.edu.tw",
							"address": "臺北市基隆路三段155巷50號",
							"customer_id": "EAB00C06",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "2120",
							"machine_model": "NanoDrop 1000",
							"issue_type": "",
							"issue_description": "合約保養：109/05（C2)",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "2020-11-17 16:29:29",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "完成",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "110/3/15開兩張 INV \n國立臺灣大學 $5000\n國立中興大學 $5000",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "吳信志 老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "完成",
							"cost_type": "Y-待開發票",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1405",
							"status": "0",
							"repair_id": "001274",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "CALL",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "1",
							"request_date": "2022-03-29 00:00:00",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "14707",
							"contact_name": "褚紹英 博士",
							"department": "",
							"work_phone": "02-27898778",
							"cell_phone": "",
							"email": "linchu58@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "asasdsad",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "Y-依發票",
							"message": "",
							"company_sname": "1234",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1404",
							"status": "0",
							"repair_id": "001273",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-03-22 00:00:00",
							"request_user_id": "5",
							"request_user_name": "陳顥文",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "14707",
							"contact_name": "褚紹英 博士",
							"department": "",
							"work_phone": "02-27898778",
							"cell_phone": "",
							"email": "linchu58@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "123",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1403",
							"status": "2",
							"repair_id": "001272",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2022-03-22 10:10:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-03-22 00:00:00",
							"request_user_id": "5",
							"request_user_name": "陳顥文",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "14707",
							"contact_name": "褚紹英 博士",
							"department": "",
							"work_phone": "02-27898778",
							"cell_phone": "",
							"email": "linchu58@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "123",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "2022-03-22 10:30:00",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "2022-03-19 00:00:00",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-03-09 00:00:00",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1402",
							"status": "4",
							"repair_id": "001271",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "18",
							"start_date": "2022-03-22 09:10:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2022-03-22 00:00:00",
							"request_user_id": "5",
							"request_user_name": "陳顥文",
							"company_id": "1617",
							"company_name": "國立中興大學 生命科學系",
							"contact_id": "19202",
							"contact_name": "陳全木 老師/陳昱璇 小姐",
							"department": "",
							"work_phone": "04-2284-0319#702",
							"cell_phone": "",
							"email": "water5657@hotmail.com",
							"address": "402 台中市南區興大路145號",
							"customer_id": "EAF00B02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum CT",
							"shipping_record_id": "",
							"serial_number": "IS1239N6062",
							"machine_model": "IVIS Spectrum CT",
							"issue_type": "",
							"issue_description": "123",
							"fix_user_id": "44",
							"fix_user_name": "陳韋翰",
							"repair_date": "2022-03-22 09:20:00",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "123",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "123",
							"arrival_time": "",
							"leave_time": "2022-03-05 00:00:00",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-03-11 00:00:00",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "陳全木",
							"location": "AAAAAA",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "123",
							"repair_result": "123",
							"cost_type": "Y-依發票",
							"message": "123",
							"company_sname": "",
							"repair_hours": "1",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1401",
							"status": "4",
							"repair_id": "001270",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "18",
							"start_date": "2022-03-22 09:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2022-03-22 00:00:00",
							"request_user_id": "5",
							"request_user_name": "陳顥文",
							"company_id": "2882",
							"company_name": "長庚醫療財團法人  林口長庚紀念醫院 幹細胞與轉譯癌症研究所",
							"contact_id": "23359",
							"contact_name": "陳鈴津 老師",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "桃園市龜山區文化一路15號",
							"customer_id": "HAC16D01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "123",
							"shipping_record_id": "",
							"serial_number": "1237",
							"machine_model": "autoMACS Pro",
							"issue_type": "",
							"issue_description": "test",
							"fix_user_id": "10",
							"fix_user_name": "蔡錦承",
							"repair_date": "2022-03-22 09:30:00",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "123",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "2022-03-10 00:00:00",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-03-01 00:00:00",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "陳鈴津",
							"location": "123",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "123",
							"repair_result": "123",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "1",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1398",
							"status": "0",
							"repair_id": "001267",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "3",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-27 14:40:24",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "1",
							"company_name": "中央研究院　",
							"contact_id": "13443",
							"contact_name": "王學恆  先生",
							"department": "",
							"work_phone": "02-2789-9505",
							"cell_phone": "",
							"email": "Pdn2636@gate.sinica.edu.tw",
							"address": "",
							"customer_id": "AAA00A00",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "測試",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "細  生  所／採購人員",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1400",
							"status": "4",
							"repair_id": "001269",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "8",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "46",
							"start_date": "2022-02-15 00:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2022-02-15 00:00:00",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "2882",
							"company_name": "長庚醫療財團法人  林口長庚紀念醫院 幹細胞與轉譯癌症研究所",
							"contact_id": "23359",
							"contact_name": "陳鈴津 老師",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "桃園市龜山區文化一路15號",
							"customer_id": "HAC16D01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "1237",
							"machine_model": "autoMACS Pro",
							"issue_type": "",
							"issue_description": "Test",
							"fix_user_id": "10,29",
							"fix_user_name": "蔡錦承,林映均",
							"repair_date": "2022-02-16 00:00:00",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "Test3",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "Test6",
							"arrival_time": "",
							"leave_time": "2022-06-15 00:00:00",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-02-15 00:00:00",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "陳鈴津",
							"location": "AAAAAA",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "Test2",
							"repair_result": "Test4",
							"cost_type": "Y-依發票",
							"message": "Test5",
							"company_sname": "",
							"repair_hours": "5",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1399",
							"status": "4",
							"repair_id": "001268",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "8",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "46",
							"start_date": "2022-02-15 00:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2022-02-15 00:00:00",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "2882",
							"company_name": "長庚醫療財團法人  林口長庚紀念醫院 幹細胞與轉譯癌症研究所",
							"contact_id": "23359",
							"contact_name": "陳鈴津 老師",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "桃園市龜山區文化一路15號",
							"customer_id": "HAC16D01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "autoMACS",
							"shipping_record_id": "",
							"serial_number": "1237",
							"machine_model": "autoMACS Pro",
							"issue_type": "",
							"issue_description": "Test",
							"fix_user_id": "29",
							"fix_user_name": "林映均",
							"repair_date": "2022-02-16 00:00:00",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "Test3",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "2022-06-15 00:00:00",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2022-02-15 00:00:00",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "陳鈴津",
							"location": "Qqq",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "Test2",
							"repair_result": "Test4",
							"cost_type": "Y-依發票",
							"message": "Test5",
							"company_sname": "",
							"repair_hours": "5",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "130-096-533",
									"part_name": "CD4+ T Cell Isolation Kit, human",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								},
								{
									"part_id": "130-096-730",
									"part_name": "Tumor Dissociation Kit, mouse",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1397",
							"status": "0",
							"repair_id": "001266",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1,11,12,13,2,3,4,5,6,7,8,9",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "14707",
							"contact_name": "褚紹英 博士",
							"department": "",
							"work_phone": "02-27898778",
							"cell_phone": "",
							"email": "linchu58@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "",
							"company_owner": "褚紹英",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1396",
							"status": "0",
							"repair_id": "001265",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1395",
							"status": "0",
							"repair_id": "001264",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1394",
							"status": "0",
							"repair_id": "001263",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1393",
							"status": "0",
							"repair_id": "001262",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1392",
							"status": "0",
							"repair_id": "001261",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1391",
							"status": "0",
							"repair_id": "001260",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1390",
							"status": "0",
							"repair_id": "001259",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1389",
							"status": "0",
							"repair_id": "001258",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1388",
							"status": "0",
							"repair_id": "001257",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1387",
							"status": "0",
							"repair_id": "001256",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1386",
							"status": "0",
							"repair_id": "001255",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1385",
							"status": "0",
							"repair_id": "001254",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1384",
							"status": "0",
							"repair_id": "001253",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1383",
							"status": "0",
							"repair_id": "001252",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1382",
							"status": "0",
							"repair_id": "001251",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1381",
							"status": "0",
							"repair_id": "001250",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1380",
							"status": "0",
							"repair_id": "001249",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1379",
							"status": "0",
							"repair_id": "001248",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 00:00:00",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1378",
							"status": "0",
							"repair_id": "001247",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:02:20",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "test",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1377",
							"status": "0",
							"repair_id": "001246",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:02:06",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1376",
							"status": "0",
							"repair_id": "001245",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:55",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "512",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1375",
							"status": "0",
							"repair_id": "001244",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:46",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1374",
							"status": "0",
							"repair_id": "001243",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:34",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "256",
							"company_name": "中央研究院　基因體研究中心",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAG00A39",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1373",
							"status": "0",
							"repair_id": "001242",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:25",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1372",
							"status": "0",
							"repair_id": "001241",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:13",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1371",
							"status": "0",
							"repair_id": "001240",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 20:01:01",
							"request_user_id": "46",
							"request_user_name": "劉威宏",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1370",
							"status": "0",
							"repair_id": "001239",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2022-01-13 19:59:59",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "TEST",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1364",
							"status": "4",
							"repair_id": "001233",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1,2,3",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-08-08 13:00:20",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-06-01 00:00:00",
							"request_user_id": "19",
							"request_user_name": "Weber",
							"company_id": "10",
							"company_name": "中央研究院  RNAi Core",
							"contact_id": "13536",
							"contact_name": "鄭金松 老師/林志隆 博士",
							"department": "",
							"work_phone": "02-27898763#16",
							"cell_phone": "",
							"email": "",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAA00A09",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "Test",
							"fix_user_id": "37",
							"fix_user_name": "oo",
							"repair_date": "2021-08-08 15:50:00",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "我的朋友",
							"arrival_time": "",
							"leave_time": "2021-11-11 23:40:18",
							"create_user": "Weber",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2029-08-05 15:00:10",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "鄭金松",
							"location": "12345678",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "我的心中的一",
							"cost_type": "Y-依發票",
							"message": "我們要是你",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1369",
							"status": "2",
							"repair_id": "001238",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2020-09-22 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-10-18 09:16:58",
							"request_user_id": "1",
							"request_user_name": "測試帳號一",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "machine_model",
							"issue_type": "",
							"issue_description": "issue_description",
							"fix_user_id": "1,2",
							"fix_user_name": "測試帳號一,測試使用者",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "測試帳號一",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "L201806002",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1368",
							"status": "2",
							"repair_id": "001237",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2020-09-22 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-10-18 09:16:40",
							"request_user_id": "1",
							"request_user_name": "測試帳號一",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "machine_model",
							"issue_type": "",
							"issue_description": "issue_description",
							"fix_user_id": "1,2",
							"fix_user_name": "測試帳號一,測試使用者",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "測試帳號一",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "L201806002",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1367",
							"status": "0",
							"repair_id": "001236",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-09-28 10:00:11",
							"request_user_id": "1",
							"request_user_name": "測試帳號一",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "issue_description",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "測試帳號一",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1366",
							"status": "2",
							"repair_id": "001235",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2020-09-22 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-09-28 10:00:10",
							"request_user_id": "1",
							"request_user_name": "測試帳號一",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "machine_model",
							"issue_type": "",
							"issue_description": "issue_description",
							"fix_user_id": "1,2",
							"fix_user_name": "測試帳號一,測試使用者",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "測試帳號一",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "L201806002",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1365",
							"status": "2",
							"repair_id": "001234",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "0",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2020-09-22 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-09-28 00:00:00",
							"request_user_id": "1",
							"request_user_name": "測試帳號一",
							"company_id": "0",
							"company_name": "",
							"contact_id": "0",
							"contact_name": "",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "",
							"customer_id": "",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "machine_model",
							"issue_type": "",
							"issue_description": "issue_description",
							"fix_user_id": "1,2",
							"fix_user_name": "測試帳號一,測試使用者",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "測試帳號一",
							"used_status": "",
							"ext_number": "",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "",
							"repair_priority": "",
							"company_owner": "",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "L201806002",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1363",
							"status": "1",
							"repair_id": "001232",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "11",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "45,8",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-24 00:00:00",
							"request_user_id": "7",
							"request_user_name": "曾昭賢S01",
							"company_id": "584483",
							"company_name": "國防醫學院　微生物及免疫學研究所",
							"contact_id": "32825",
							"contact_name": "張聰賢 老師",
							"department": "",
							"work_phone": "02-87923100#18486",
							"cell_phone": "",
							"email": "changth@mail.ndmctsgh.edu.tw",
							"address": "台北市內湖區民權東路六段161號8樓8223室",
							"customer_id": "EDB00A10",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "gM+MACSMix+EVE",
							"issue_type": "",
							"issue_description": "國防gM+MACSMix+ EVE標案\n請準備交機時需要檢附的文件\nBy 6/30",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "曾昭賢S01",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "張聰賢",
							"location": "",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "1. 原廠製造證明文件一份\n2. 原廠操作及維修手冊二份\n3. 繁體中文操作及維修手冊二份 \n4. 以上文件項均附電子檔光碟各二片\t\n5. 原廠維護保養技術手冊二份\n6. 簡易中文操作吊牌二份\n7.標註2021年一月一日以後出廠之新品",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1338",
							"status": "2",
							"repair_id": "001211",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-18 10:00:23",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-17 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "3531",
							"company_name": "太景生物科技股份有限公司",
							"contact_id": "25793",
							"contact_name": "張綾茵 小姐",
							"department": "",
							"work_phone": "02-8177-7020#1827",
							"cell_phone": "",
							"email": "lychang@taigenbiotech.com.tw",
							"address": "臺北市內湖區新明路138號7樓",
							"customer_id": "ZBA00S01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "TopCount",
							"shipping_record_id": "",
							"serial_number": "50737",
							"machine_model": "C384V01",
							"issue_type": "",
							"issue_description": "TopCount復機檢測 ( sn: 50737)",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "2021-05-18 12:30:23",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1檢查儀器發現cooler異常不過電\n2檢查主機發現內部電腦機板battery low cannot keep settings\n3借用客戶10A fuse test cooler ok\n4 calibration ok\n5待更換cooler fuse 及報價",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "客戶電話號碼改成02-8177-7020#1827",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-18 12:13:23",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "7F",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "待確認",
							"message": "",
							"company_sname": "",
							"repair_hours": "2.5",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1347",
							"status": "4",
							"repair_id": "001218",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "11",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "25",
							"start_date": "2021-05-21 15:30:11",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "25",
							"request_user_name": "陳俊宇",
							"company_id": "533",
							"company_name": "行政院原子能委員會核能研究所 同位素應用組",
							"contact_id": "15643",
							"contact_name": "王世民 博士",
							"department": "",
							"work_phone": "03-4711400 #7234",
							"cell_phone": "",
							"email": "funnyjoe@iner.gov.tw",
							"address": "桃園市龍潭區佳安村文化路1000號",
							"customer_id": "BEA00C11",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Oxidizer 307",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "請協助製作Oxidizer Performance Verification check list，完成後請提供給Alex",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "2021-05-21 15:30:11",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已經把檔案寄給俊宇",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "已經把檔案寄給俊宇，請結案",
							"arrival_time": "2021-05-21 15:30:11",
							"leave_time": "",
							"create_user": "陳俊宇",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-21 12:29:43",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "王世民",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "2.5",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1362",
							"status": "4",
							"repair_id": "001231",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "45",
							"start_date": "2021-05-21 11:30:48",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-05-21 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "3446",
							"company_name": "光麗生醫股份有限公司",
							"contact_id": "32774",
							"contact_name": "陳慶容 小姐",
							"department": "",
							"work_phone": "02-2694-9880 #501",
							"cell_phone": "",
							"email": "joy859155@guangli.com.tw",
							"address": "新北市汐止區康寧街169巷31號11樓之1",
							"customer_id": "ZBA00B50",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "來電詢問試劑(冷藏/乾冰)運送過程有沒有溫度記錄",
							"fix_user_id": "40,49",
							"fix_user_name": "曾昭賢C01,王博立",
							"repair_date": "2021-05-21 11:50:48",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已聯繫陳欣小姐，回覆問題和方法。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-21 11:50:48",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "李艾臻",
							"location": "",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "陳小姐 02-26949880#139",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1354",
							"status": "1",
							"repair_id": "001223",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "28",
							"request_user_name": "吳志岳",
							"company_id": "332",
							"company_name": "台灣電力股份有限公司 放射試驗室",
							"contact_id": "33150",
							"contact_name": "顧雨軒 先生",
							"department": "",
							"work_phone": "02-2638-1068#545",
							"cell_phone": "",
							"email": "u810554@taipower.com.tw",
							"address": "新北市石門區乾華里小坑12號",
							"customer_id": "BCA00A05",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "SGLO34191113",
							"machine_model": "A491000",
							"issue_type": "",
							"issue_description": "不能開機",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "客戶來電說儀器已恢復正常故不用到場維修，請結案",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "吳志岳",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "李碧隆",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1361",
							"status": "4",
							"repair_id": "001230",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "8,42",
							"start_date": "2021-05-21 10:00:29",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-21 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "1617",
							"company_name": "國立中興大學 生命科學系",
							"contact_id": "19202",
							"contact_name": "陳全木 老師/陳昱璇 小姐",
							"department": "",
							"work_phone": "04-2284-0319#702",
							"cell_phone": "",
							"email": "water5657@hotmail.com",
							"address": "402 台中市南區興大路145號",
							"customer_id": "EAF00B02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum CT",
							"shipping_record_id": "",
							"serial_number": "IS1239N6062",
							"machine_model": "IVIS Spectrum CT",
							"issue_type": "",
							"issue_description": "LI 軟體會重複開啟",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-21 11:00:29",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.請客戶重開機pc再開LI，未出現問題。\n2.測試數次都正常。\n3.完成測試。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告寄陳昱璇",
							"arrival_time": "2021-05-21 10:00:29",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳全木",
							"location": "應用科科技大樓10樓1014室",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "1",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1355",
							"status": "2",
							"repair_id": "001224",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-06-15 11:00:53",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "28",
							"request_user_name": "吳志岳",
							"company_id": "3536",
							"company_name": "扶康健康事業股份有限公司",
							"contact_id": "25826",
							"contact_name": "曾愉雯 小姐",
							"department": "",
							"work_phone": "0905-868-944",
							"cell_phone": "",
							"email": "wiona@farmacomp.com",
							"address": "臺北市信義區光復南路417巷163號",
							"customer_id": "ZBA00T02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "JANUS G3",
							"shipping_record_id": "",
							"serial_number": "JA1729N2087",
							"machine_model": "YJL8001/C",
							"issue_type": "",
							"issue_description": "單次保養及單次體積校正",
							"fix_user_id": "28,29",
							"fix_user_name": "吳志岳,林映均",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-21 09:30:53",
							"leave_time": "",
							"create_user": "吳志岳",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support,Service",
							"repair_priority": "普通件",
							"company_owner": "許懷仁",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1159",
							"status": "4",
							"repair_id": "001047",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "7",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "42",
							"start_date": "2021-05-18 13:30:33",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "2940",
							"company_name": "中國醫藥大學附設醫院　幹細胞研究中心",
							"contact_id": "23587",
							"contact_name": "林嬌玲 組長",
							"department": "",
							"work_phone": "04-22052121#5226 or/#1511",
							"cell_phone": "",
							"email": "t0046@mail.cmuh.org.tw",
							"address": "台中市育德路2號",
							"customer_id": "HAF05I01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "AZY2018715",
							"machine_model": "NanoDrop One",
							"issue_type": "",
							"issue_description": "保固保養：110/05",
							"fix_user_id": "44",
							"fix_user_name": "陳韋翰",
							"repair_date": "2021-05-18 15:30:39",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "儀器已完成校正保養狀況良好",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "1-2（保固至111/8/24）",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-18 18:14:30",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "葉士芃",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "N",
							"company_sname": "",
							"repair_hours": "2",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1157",
							"status": "4",
							"repair_id": "001045",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "42",
							"start_date": "2021-05-18 16:00:19",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "1783",
							"company_name": "亞洲大學 保健營養生技學系",
							"contact_id": "19620",
							"contact_name": "黃淑慧 小姐",
							"department": "",
							"work_phone": "04-23323456#5172",
							"cell_phone": "",
							"email": "shuhuihuang@asia.edu.tw",
							"address": "41354臺中市霧峰區柳豐路500號",
							"customer_id": "EAF35B02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "P440",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "合約保養：110/05（C2）",
							"fix_user_id": "44",
							"fix_user_name": "陳韋翰",
							"repair_date": "2021-05-18 17:00:19",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "儀器已完成校正保養狀況良好",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2 請寄黃小姐",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-18 01:20:24",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "謝承紘  老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "1",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1360",
							"status": "1",
							"repair_id": "001229",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "3239",
							"company_name": "長庚醫療財團法人 高雄長庚紀念醫院 核子醫學科",
							"contact_id": "24736",
							"contact_name": "陳鐵祥 先生",
							"department": "",
							"work_phone": "07-7317123#3007",
							"cell_phone": "",
							"email": "m12062@adm.cgmh.org.tw",
							"address": "83301高雄市鳥松區大埤路123號",
							"customer_id": "HAL15U01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Wizard2 Series",
							"shipping_record_id": "",
							"serial_number": "SGWZ14150261",
							"machine_model": "2470-0200",
							"issue_type": "",
							"issue_description": "Barcode Reader 功能異常",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "",
							"content": "",
							"job_title": "儀器課",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-06-01 18:11:01",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳窗達 先生",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1359",
							"status": "1",
							"repair_id": "001228",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "335",
							"company_name": "台灣電力股份有限公司 第三核能發電廠",
							"contact_id": "14939",
							"contact_name": "林昌盛 先生",
							"department": "",
							"work_phone": "08-8893470#2821",
							"cell_phone": "",
							"email": "u879635@taipower.com.tw",
							"address": "屏東縣恆春鎮南灣路387號",
							"customer_id": "BCA00B01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "DG02130163",
							"machine_model": "B291001",
							"issue_type": "",
							"issue_description": "Light Shutter功能異常",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-25 18:08:23",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "林昌盛",
							"location": "1號機",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1358",
							"status": "1",
							"repair_id": "001227",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "49",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "27",
							"request_user_name": "蔡宇騏",
							"company_id": "726",
							"company_name": "財團法人農業科技研究院  動物產業組",
							"contact_id": "16124",
							"contact_name": "楊程堯 老師/洪紹文 先生",
							"department": "",
							"work_phone": "037-585-832",
							"cell_phone": "",
							"email": "lymphoma2002@yahoo.com.tw",
							"address": "苗栗縣竹南鎮頂埔里科東二路52號",
							"customer_id": "DBC00A01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "U:Genius",
							"shipping_record_id": "",
							"serial_number": "SYUG/1326",
							"machine_model": "UG3",
							"issue_type": "",
							"issue_description": "開機有時無法進入作業系統  請聯絡037 585829 紀小姐",
							"fix_user_id": "47",
							"fix_user_name": "陳維明",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "蔡宇騏",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "翁仲男",
							"location": "",
							"brand": "SYNGENE",
							"product_line": "SYNGENE",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1357",
							"status": "4",
							"repair_id": "001226",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-20 15:20:44",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "2182",
							"company_name": "國立屏東科技大學 獸醫系",
							"contact_id": "20894",
							"contact_name": "莊秀琪 老師",
							"department": "",
							"work_phone": "",
							"cell_phone": "",
							"email": "",
							"address": "91201 屏東縣內埔鄉學府路1號",
							"customer_id": "EBM00B01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "NanoDrop詢價",
							"fix_user_id": "50",
							"fix_user_name": "戴自勇",
							"repair_date": "2021-05-20 15:50:44",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-20 15:20:44",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "莊秀琪 老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "聯絡人 林先生0932-514-384",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1165",
							"status": "4",
							"repair_id": "001053",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "49",
							"start_date": "2021-05-20 13:30:02",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "465",
							"company_name": "財團法人國家衛生研究院　神經及精神醫學研究中心",
							"contact_id": "15440",
							"contact_name": "陳慧諴 老師/張偉唐 先生",
							"department": "",
							"work_phone": "037-246166#36711",
							"cell_phone": "",
							"email": "extraby123@nhri.edu.tw",
							"address": "350 苗栗縣竹南鎮科研路35號",
							"customer_id": "BDD00J04",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "5308",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "合約保養：110/05（C2）",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "2021-05-20 16:00:02",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "儀器保養、校正及確效，保養後功能正常，確效符合標準。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2 Report 給聯絡人。相關文件蓋公司章。",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳慧諴 老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1195",
							"status": "2",
							"repair_id": "001083",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "49",
							"start_date": "2021-05-24 09:00:51",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "878",
							"company_name": "國立台灣大學 生化科學研究所",
							"contact_id": "16704",
							"contact_name": "何佳安 老師/洪翎鈞 小姐",
							"department": "",
							"work_phone": "02-33664438",
							"cell_phone": "",
							"email": "hunglingchun@ntu.edu.tw",
							"address": "臺北市羅斯福路四段1號",
							"customer_id": "EAB00I07",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Lumina Series",
							"shipping_record_id": "",
							"serial_number": "IS1121N5601",
							"machine_model": "IVIS Lumina II",
							"issue_type": "",
							"issue_description": "合約保養：110/05（FM）",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2 已付清 (合約至110/10/12)",
							"arrival_time": "2021-05-20 15:00:51",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "何佳安",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1192",
							"status": "4",
							"repair_id": "001080",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "49",
							"start_date": "2021-05-20 10:00:28",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "468",
							"company_name": "財團法人國家衛生研究院　奈米醫學研究中心",
							"contact_id": "15460",
							"contact_name": "陳仁焜 博士/廖承澤 先生",
							"department": "",
							"work_phone": "037-246166#38128",
							"cell_phone": "",
							"email": "wei-neng@nhri.edu.tw",
							"address": "苗栗縣竹南鎮科研路35號",
							"customer_id": "BDD00L02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Wizard2 Series",
							"shipping_record_id": "",
							"serial_number": "24800039",
							"machine_model": "2480-0001",
							"issue_type": "",
							"issue_description": "合約保養：110/05",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "2021-05-20 12:00:28",
							"content": "",
							"job_title": "Wizard使用者",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.儀器外部清潔完成。\n2.依照Check List 完成保養、校正及確效。\n3.Test run ok。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "1-2 已付款(內轉)。Report 給聯絡人。",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳仁焜 博士",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1356",
							"status": "1",
							"repair_id": "001225",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "28",
							"request_user_name": "吳志岳",
							"company_id": "2253",
							"company_name": "國防醫學院　藥學系所",
							"contact_id": "32661",
							"contact_name": "藥理所 洪浩淵 老師",
							"department": "",
							"work_phone": "02-87923100#18679",
							"cell_phone": "",
							"email": "hyhung@mail.ndmctsgh.edu.tw",
							"address": "臺北市內湖區民權東路六段161號",
							"customer_id": "EDB00D01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "424209",
							"machine_model": "A290001",
							"issue_type": "",
							"issue_description": "SNC測試 with new STD",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "吳志岳",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "鮑力恆",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1318",
							"status": "4",
							"repair_id": "001194",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-13 09:30:58",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-13 00:00:00",
							"request_user_id": "45",
							"request_user_name": "徐明嘉",
							"company_id": "585324",
							"company_name": "臺北市立聯合醫院 教學研究部",
							"contact_id": "33228",
							"contact_name": "謝欣玲 小姐",
							"department": "",
							"work_phone": "02-27093600#3826",
							"cell_phone": "",
							"email": "z3140@tpech.gov.tw",
							"address": "",
							"customer_id": "CBA00A08",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "7332",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "校正需求",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "2021-05-13 11:00:58",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "機器已完成清潔、保養、校正及確效測試\n確效測試結果符合標準，機器測量精確具再現象",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "寄聯絡人\n\n更新地址仁愛院區8西",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "徐明嘉",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "完成",
							"cost_type": "Y-待開發票",
							"message": "",
							"company_sname": "",
							"repair_hours": "1",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1351",
							"status": "4",
							"repair_id": "001211-1",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1,2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "7",
							"start_date": "2021-05-19 17:20:25",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "28",
							"request_user_name": "吳志岳",
							"company_id": "3531",
							"company_name": "太景生物科技股份有限公司",
							"contact_id": "25793",
							"contact_name": "張綾茵 小姐",
							"department": "",
							"work_phone": "02-8177-7020#1827",
							"cell_phone": "",
							"email": "lychang@taigenbiotech.com.tw",
							"address": "臺北市內湖區新明路138號7樓",
							"customer_id": "ZBA00S01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "TopCount",
							"shipping_record_id": "",
							"serial_number": "050737",
							"machine_model": "C384V01",
							"issue_type": "",
							"issue_description": "TopCount復機檢測 ( sn: 050737)",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "2021-05-19 17:50:25",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1更換cooler fuse test時有熔斷\n2再次更換cooler fuse test cool down to 22 C. Ok\n3待報價cooler cart and stand alone cooler",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "同上",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "吳志岳",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 17:33:25",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "7F",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "Y-待開發票",
							"message": "",
							"company_sname": "",
							"repair_hours": "0.5",
							"review_status_id": "0",
							"repair_source_id": "001211",
							"repair_count": "1",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1330",
							"status": "4",
							"repair_id": "001204",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-14 17:10:39",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-14 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "701",
							"company_name": "工業技術研究院 生醫與醫材研究所  分子診斷醫材技術部",
							"contact_id": "16032",
							"contact_name": "陳振泰 博士",
							"department": "",
							"work_phone": "0915-139-125",
							"cell_phone": "",
							"email": "ivdteddy@itri.org.tw",
							"address": "新竹縣竹東鎮中興路四段195號",
							"customer_id": "DAA00D19",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "詢問細胞株BW119266",
							"fix_user_id": "49",
							"fix_user_name": "王博立",
							"repair_date": "2021-05-14 17:30:39",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已聯繫周小姐報價格，等周跟長官和同事確認經費和採購方式，再請我準備估價單和文件做申購。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "X",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "陳振泰",
							"location": "",
							"brand": "PerkinElmer invivo",
							"product_line": "PerkinElmer invivo",
							"problem": "聯絡人： 周小姐0953-866-883\n\nBW119266  BiowareBriteA549-RedFLuc 定價197900  售價168200",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1344",
							"status": "3",
							"repair_id": "001216",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "8",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "46,8,25",
							"start_date": "2021-05-19 10:10:15",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "41",
							"request_user_name": "李炳毅M01",
							"company_id": "1497",
							"company_name": "長庚大學 化工與材料工程系",
							"contact_id": "18808",
							"contact_name": "陳志平 教授/郭章一 先生",
							"department": "",
							"work_phone": "03-2118800#5604",
							"cell_phone": "",
							"email": "onesky1997@gmail.com",
							"address": "桃園市龜山區文化一路259號",
							"customer_id": "EAC00W01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "Syringe dispenser training of ROKIT invivo",
							"fix_user_id": "41,45",
							"fix_user_name": "李炳毅M01,徐明嘉",
							"repair_date": "2021-05-19 11:40:15",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "不寄",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李炳毅M01",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 09:15:26",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "陳志平",
							"location": "",
							"brand": "ROKIT",
							"product_line": "ROKIT",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "2",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1353",
							"status": "4",
							"repair_id": "000691-2",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50,44",
							"start_date": "2021-05-20 09:30:56",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "3809",
							"company_name": "東宇生物科技股份有限公司",
							"contact_id": "27000",
							"contact_name": "陳毓雯 小姐",
							"department": "",
							"work_phone": "06-505-2755#2597",
							"cell_phone": "",
							"email": "promd1905@gmail.com",
							"address": "臺南市善化區大利二路1號",
							"customer_id": "ZKA00C01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "LabChip GX Touch 24",
							"shipping_record_id": "",
							"serial_number": "GT1821N0921",
							"machine_model": "LabChip GX Touch 24",
							"issue_type": "",
							"issue_description": "Invalid instrument detected(bad first ladder)",
							"fix_user_id": "39,44",
							"fix_user_name": "鄭進展,陳韋翰",
							"repair_date": "2021-05-20 11:30:56",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.測量客戶提供的三組已使用過的Chip的sipper長度，\n   帶回討論。\n2.找出bad first ladder 的data,與客戶討論可能的原\n    因。\n3.將data與客戶的疑問帶回詢問原廠。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告寄陳毓雯（不含圖檔）",
							"arrival_time": "2021-05-20 11:20:56",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "洪錦富",
							"location": "2F",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "2",
							"review_status_id": "0",
							"repair_source_id": "000691",
							"repair_count": "2",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1290",
							"status": "3",
							"repair_id": "001169",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "12",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "9",
							"start_date": "2021-05-05 17:20:52",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-05 00:00:00",
							"request_user_id": "29",
							"request_user_name": "林映均",
							"company_id": "3873",
							"company_name": "博克科技股份有限公司",
							"contact_id": "27184",
							"contact_name": "林映均",
							"department": "",
							"work_phone": "0978-866-798",
							"cell_phone": "",
							"email": "",
							"address": "臺北市新湖二路162號4樓之1",
							"customer_id": "ZZZ",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "G531",
							"machine_model": "NanoDrop 1000",
							"issue_type": "",
							"issue_description": "恭誌demo有問題，帶回檢修",
							"fix_user_id": "29",
							"fix_user_name": "林映均",
							"repair_date": "2021-05-05 17:20:52",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "Initialization fail\n\n更換PCBA \n校正完成\nOk",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "已收回為公司租賃機，不需寄報告給客戶\n紀錄留存用",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "林映均",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "蔡錦承",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "512-240400",
									"part_name": "PCBA ND1K Sn 3792+(庫存品)",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1158",
							"status": "1",
							"repair_id": "001046",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "42",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "1626",
							"company_name": "國立中興大學 生物科技發展中心",
							"contact_id": "19233",
							"contact_name": "翁瓊華 老師",
							"department": "",
							"work_phone": "04-2284-0450#6031",
							"cell_phone": "",
							"email": "chwung@dragon.nchu.edu.tw",
							"address": "402 台中市南區興大路145號",
							"customer_id": "EAF00C03",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "A964",
							"machine_model": "NanoDrop 1000",
							"issue_type": "",
							"issue_description": "合約保養：110/06（C2）",
							"fix_user_id": "44",
							"fix_user_name": "陳韋翰",
							"repair_date": "",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "翁瓊華 老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1236",
							"status": "3",
							"repair_id": "001115",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "39,44",
							"start_date": "2021-05-18 16:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-03 00:00:00",
							"request_user_id": "6",
							"request_user_name": "黃韻璇",
							"company_id": "1771",
							"company_name": "中國醫藥大學 研發處",
							"contact_id": "33148",
							"contact_name": "傅書琴 小姐",
							"department": "",
							"work_phone": "0921-736-369",
							"cell_phone": "",
							"email": "",
							"address": "40402 台中市北區學士路91號",
							"customer_id": "EAF16E01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum Series",
							"shipping_record_id": "",
							"serial_number": "IS2012N7906",
							"machine_model": "IVIS Spectrum",
							"issue_type": "",
							"issue_description": "帶回滯遲電路",
							"fix_user_id": "42",
							"fix_user_name": "葉恭誌",
							"repair_date": "2021-05-18 16:00:51",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "5/14已帶回，詳如001199服務單",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃韻璇",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support,Sales,Service",
							"repair_priority": "急件",
							"company_owner": "廖文欣",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1317",
							"status": "3",
							"repair_id": "001193",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "26",
							"start_date": "2021-05-18 17:30:49",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-12 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "3460",
							"company_name": "佳生科技顧問股份有限公司",
							"contact_id": "25486",
							"contact_name": "張心瑜 小姐",
							"department": "",
							"work_phone": "02-55580000#1101",
							"cell_phone": "",
							"email": "dolly.chang@ppccro.com",
							"address": "臺北市南港區園區街3號11樓",
							"customer_id": "ZBA00B64",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "T869",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "要校正保養，請回電，謝謝",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "2021-05-18 17:40:49",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已與客戶聯繫，再約保養時間。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support,Service",
							"repair_priority": "普通件",
							"company_owner": "陳恒恕",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1352",
							"status": "1",
							"repair_id": "001222",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-20 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "332",
							"company_name": "台灣電力股份有限公司 放射試驗室",
							"contact_id": "14931",
							"contact_name": "羅巧婷 小姐",
							"department": "",
							"work_phone": "02-2638-1068#504",
							"cell_phone": "",
							"email": "u035941@taipower.com.tw",
							"address": "新北市石門區乾華里小坑12號",
							"customer_id": "BCA00A05",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "詢價6013187 6013729 6013721",
							"fix_user_id": "26",
							"fix_user_name": "蕭惠中",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "李碧隆",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "羅巧婷 說她分機503\n\n6013187  PERMAFLUOR E+/ 4x2.5L(危險品)\n6013729  CARBO-SORB E / 4x2.5L(危險品)\n6013721  CARBOSORB E/1L(危險品)",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1340",
							"status": "3",
							"repair_id": "001213",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "26",
							"start_date": "2021-05-17 13:30:55",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-17 00:00:00",
							"request_user_id": "29",
							"request_user_name": "林映均",
							"company_id": "2578",
							"company_name": "臺北榮民總醫院 核醫科",
							"contact_id": "22294",
							"contact_name": "楊宛甄 小姐",
							"department": "",
							"work_phone": "02-28757301#531,#538",
							"cell_phone": "",
							"email": "wjyang@vghtpe.gov.tw",
							"address": "臺北市北投區石牌路二段201號",
							"customer_id": "HAB10O01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Wizard2 Series",
							"shipping_record_id": "",
							"serial_number": "DG07118106",
							"machine_model": "2470-0200",
							"issue_type": "",
							"issue_description": "New Protocol setting",
							"fix_user_id": "29",
							"fix_user_name": "林映均",
							"repair_date": "2021-05-17 16:00:55",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "新增 WizUI & WorkOut protocol :\n\n#15 FT4\n#16 hTSH\n#18 TGAB\n#39 HAG\n#58 CA72-4\n\n已根據試劑說明完成初步設定，\n待上樣測試後再看是否需進行調整。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "Mail to 楊小姐",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "林映均",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "新增項目",
							"repair_result": "",
							"cost_type": "N",
							"message": "No",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1350",
							"status": "4",
							"repair_id": "001221",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "4",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-19 10:30:59",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "28",
							"request_user_name": "吳志岳",
							"company_id": "3282",
							"company_name": "汎球生物科技股份有限公司",
							"contact_id": "24898",
							"contact_name": "周耀傑 先生",
							"department": "",
							"work_phone": "02-77517062",
							"cell_phone": "",
							"email": "YaochiehChou@eurofins.com",
							"address": "新北市五股區五工六路25號",
							"customer_id": "IAA00A01-1",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "431687",
							"machine_model": "A290001",
							"issue_type": "",
							"issue_description": "3H E^2/B low",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "2021-05-19 16:30:59",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1檢查SNC報告3H E^2/B皆不足180\n2更換備品PMT後SNC 3H E^2/B 不足180\n3 更換另一組備品PMT後SNC 3H E^2/B 不足180\n4復原原來的PMT SNC待report\n5待訂購新品再測試",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "同上CC王大",
							"arrival_time": "2021-05-19 16:30:59",
							"leave_time": "",
							"create_user": "吳志岳",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 16:37:59",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "大河內弘治",
							"location": "4F",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "6",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1342",
							"status": "2",
							"repair_id": "001215",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "7",
							"start_date": "2021-05-19 15:50:03",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-18 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "1024",
							"company_name": "臺大醫學院　微生物學科暨研究所",
							"contact_id": "17159",
							"contact_name": "徐華蔓 小姐",
							"department": "",
							"work_phone": "02-2312-3456#88282",
							"cell_phone": "",
							"email": "",
							"address": "臺北市仁愛路一段1號",
							"customer_id": "EAB05L05",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "0616",
							"machine_model": "NanoDrop Lite",
							"issue_type": "",
							"issue_description": "王先生 0920-301-847 來電說儀器出現error msg “E00000402”",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "待詢問原廠，安排後續維修",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-19 15:50:03",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "鄧述諄 老師",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1346",
							"status": "4",
							"repair_id": "001217",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "2021-05-19 13:30:56",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "335",
							"company_name": "台灣電力股份有限公司 第三核能發電廠",
							"contact_id": "14939",
							"contact_name": "林昌盛 先生",
							"department": "",
							"work_phone": "08-8893470#2821",
							"cell_phone": "",
							"email": "u879635@taipower.com.tw",
							"address": "屏東縣恆春鎮南灣路387號",
							"customer_id": "BCA00B01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "DG02130163",
							"machine_model": "B291001",
							"issue_type": "",
							"issue_description": "無法進樣",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-19 15:30:56",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.檢查後確認是Light Shutter螺絲鬆脫導致動作異常。\n2.將之固定調整與潤滑後，測試功能正常，",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告寄林昌盛",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 15:28:03",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "林昌盛",
							"location": "1號機",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1345",
							"status": "4",
							"repair_id": "000775-2",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "2021-05-19 08:20:35",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "335",
							"company_name": "台灣電力股份有限公司 第三核能發電廠",
							"contact_id": "14939",
							"contact_name": "林昌盛 先生",
							"department": "",
							"work_phone": "08-8893470#2821",
							"cell_phone": "",
							"email": "u879635@taipower.com.tw",
							"address": "屏東縣恆春鎮南灣路387號",
							"customer_id": "BCA00B01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "DG09061438",
							"machine_model": "A290001",
							"issue_type": "",
							"issue_description": "IPA ERROR:Protocol Ended prematurely samples out of order•（能譜圖異常）",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-19 15:20:35",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.換上新的7401286 Dual Low Voltage Power Supply,完成開機。\n2.執行SNC,能譜圖已正常。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告與圖檔寄林昌盛",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 11:57:30",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "林昌盛",
							"location": "2號機",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "待確認",
							"message": "",
							"company_sname": "",
							"repair_hours": "6",
							"review_status_id": "0",
							"repair_source_id": "000775",
							"repair_count": "2",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "7401286",
									"part_name": "DUAL POWER SUPPLY ASSY",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1324",
							"status": "3",
							"repair_id": "001199",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "6",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "42",
							"start_date": "2021-05-14 09:10:39",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-14 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "1771",
							"company_name": "中國醫藥大學 研發處",
							"contact_id": "33148",
							"contact_name": "傅書琴 小姐",
							"department": "",
							"work_phone": "0921-736-369",
							"cell_phone": "",
							"email": "",
							"address": "40402 台中市北區學士路91號",
							"customer_id": "EAF16E01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum Series",
							"shipping_record_id": "",
							"serial_number": "IS2012N7906",
							"machine_model": "IVIS Spectrum",
							"issue_type": "",
							"issue_description": "DVD燒錄資料有當機現象",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-14 10:30:39",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.實際燒錄到完全的過程中，在最後手動退disk時會需等待約20秒（preparing reject to disk信息消失）才真正eject完成，退出光碟片。\n2.在等待時間內做任何DVD的動作可能導致短暫無回應狀態。\n3.連續測試數次都無當機出現。\n4.帶回跳脫開關。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告與照片寄給\n傅書琴(shuchinfu@mail.chug.edu.tw)\n張銘在(t15888@mail.cmuh.edu.tw)",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-14 09:59:55",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "廖文欣",
							"location": "動物中心 10樓",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "2",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1349",
							"status": "2",
							"repair_id": "001220",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-21 09:30:36",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "48",
							"request_user_name": "黃啟璐",
							"company_id": "1389",
							"company_name": "長庚大學 生化暨分子生物學科",
							"contact_id": "33209",
							"contact_name": "王怡媚 小姐",
							"department": "",
							"work_phone": "03-218800",
							"cell_phone": "",
							"email": "o2055418@gmail.com",
							"address": "桃園縣龜山鄉文化一路259號",
							"customer_id": "EAC00A02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "0137",
							"machine_model": "NanoDrop 8000",
							"issue_type": "",
							"issue_description": "儀器一般保養。",
							"fix_user_id": "",
							"fix_user_name": "",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-19 15:30:36",
							"leave_time": "",
							"create_user": "黃啟璐",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "游佳融",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "",
							"cost_type": "Y-依發票",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1167",
							"status": "3",
							"repair_id": "001055",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "5",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "26",
							"start_date": "2021-05-14 14:00:17",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "584371",
							"company_name": "普羅王生物科技股份有限公司",
							"contact_id": "33213",
							"contact_name": "游家政 先生",
							"department": "",
							"work_phone": "02-22900233",
							"cell_phone": "",
							"email": "as58671662@gmail.com",
							"address": "新北市新莊區五權一路5號2樓-5 (203室)",
							"customer_id": "ZBA20F01-1",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "1361",
							"machine_model": "NanoDrop Lite",
							"issue_type": "",
							"issue_description": "合約保養：110/05（C2）",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "2021-05-14 16:30:44",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "儀器保養、校正及確效，保養後功能正常，確效符合標準。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2 Report 給聯絡人。相關資訊請蓋公司章。",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "林鉅逵",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1326",
							"status": "3",
							"repair_id": "001200",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "49",
							"start_date": "2021-05-14 18:10:59",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-14 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "269",
							"company_name": "中央研究院  生物多樣性研究中心",
							"contact_id": "14750",
							"contact_name": "蔡佩珍 小姐",
							"department": "",
							"work_phone": "02-27872231",
							"cell_phone": "",
							"email": "egg505@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAI00A06",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "2771",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "ND2000 校正確認",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "2021-05-14 18:10:59",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已回覆",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "X",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "急件",
							"company_owner": "陳國勤",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "蔡小姐來電說上一次校正是2020/9 之後就沒再來了\n想要確認一下合約校正是不是少做？",
							"repair_result": "完成",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1315",
							"status": "3",
							"repair_id": "001191",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "26",
							"start_date": "2021-05-14 11:10:40",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-12 00:00:00",
							"request_user_id": "26",
							"request_user_name": "蕭惠中",
							"company_id": "3333",
							"company_name": "圓祥生命科技股份有限公司",
							"contact_id": "25128",
							"contact_name": "甘弘才 先生",
							"department": "",
							"work_phone": "02-2655-8010#123",
							"cell_phone": "",
							"email": "htkan@apbioinc.com",
							"address": "台北市南港區園區街3號17樓",
							"customer_id": "ZBA00A42",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "LabChip GX II Touch HT",
							"shipping_record_id": "",
							"serial_number": "GT1919N1174",
							"machine_model": "CLS138160",
							"issue_type": "",
							"issue_description": "晶片辨識問題",
							"fix_user_id": "27,29",
							"fix_user_name": "蔡宇騏,林映均",
							"repair_date": "2021-05-14 11:10:40",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "通知客戶此爲bug 建議不使用機器時拔掉插頭可以避免此現象",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "X",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "蕭惠中",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-14 11:15:40",
							"repair_department": "Support,Service",
							"repair_priority": "普通件",
							"company_owner": "黃瑞蓮",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "跳出一下error,但是客戶重開機就好\n想確認這樣機器是否正常？",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1348",
							"status": "1",
							"repair_id": "001219",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "45",
							"start_date": "",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-19 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "584926",
							"company_name": "禮優克科技有限公司",
							"contact_id": "32999",
							"contact_name": "黃衡昊 先生",
							"department": "",
							"work_phone": "0928-712-051",
							"cell_phone": "",
							"email": "theark@theark.tw",
							"address": "臺北市中山區建國北路3段92號2樓",
							"customer_id": "ZBA00C34",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "200-074-400 CryoMACS Freezing Bag 50 詢價",
							"fix_user_id": "40",
							"fix_user_name": "曾昭賢C01",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "急件",
							"company_owner": "黃渤溢",
							"location": "",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1215",
							"status": "4",
							"repair_id": "000952-1",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "4",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "7",
							"start_date": "2021-04-27 13:30:37",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-27 00:00:00",
							"request_user_id": "45",
							"request_user_name": "徐明嘉",
							"company_id": "2437",
							"company_name": "慧智基因股份有限公司",
							"contact_id": "21764",
							"contact_name": "陳佩玉 小姐",
							"department": "",
							"work_phone": "02-2382-6615#6915",
							"cell_phone": "",
							"email": "acgh@sofiva.com.tw",
							"address": "100台北市中正區寶慶路27號",
							"customer_id": "HAB00Q02-1",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "NanoDrop",
							"shipping_record_id": "",
							"serial_number": "B759",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "合約保養：110/04（C4）",
							"fix_user_id": "45",
							"fix_user_name": "徐明嘉",
							"repair_date": "2021-04-27 13:30:37",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已確認不修理\n\n5/19送回，因無法簽收以照片代替",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "此實為000953續修，寄給聯絡人",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "徐明嘉",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Support",
							"repair_priority": "普通件",
							"company_owner": "",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "4/27帶回檢修",
							"repair_result": "送回",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "000952",
							"repair_count": "1",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1319",
							"status": "2",
							"repair_id": "001195",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "25",
							"start_date": "2021-05-20 09:30:24",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-13 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "293",
							"company_name": "中央研究院  公用動物設施",
							"contact_id": "14815",
							"contact_name": "王毓權 博士",
							"department": "",
							"work_phone": "02-27899912",
							"cell_phone": "",
							"email": "ycwlrh@gate.sinica.edu.tw",
							"address": "臺北市南港區研究院路二段128號",
							"customer_id": "AAM00E01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum Series",
							"shipping_record_id": "",
							"serial_number": "23308",
							"machine_model": "IVIS 200",
							"issue_type": "",
							"issue_description": "要安排安裝電源供應器（潘先生 0936-232953）",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "已通知王博延期再約",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-19 13:37:29",
							"repair_department": "Service",
							"repair_priority": "急件",
							"company_owner": "王毓權",
							"location": "10F",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1144",
							"status": "4",
							"repair_id": "000775-1",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "2021-04-20 09:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-04-20 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "335",
							"company_name": "台灣電力股份有限公司 第三核能發電廠",
							"contact_id": "14939",
							"contact_name": "林昌盛 先生",
							"department": "",
							"work_phone": "08-8893470#2821",
							"cell_phone": "",
							"email": "u879635@taipower.com.tw",
							"address": "屏東縣恆春鎮南灣路387號",
							"customer_id": "BCA00B01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Tri-Carb",
							"shipping_record_id": "",
							"serial_number": "DG09061438",
							"machine_model": "A290001",
							"issue_type": "",
							"issue_description": "IPA ERROR:Protocol Ended prematurely samples out of order•（能譜圖異常）",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-04-20 11:50:15",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.換上analog I/O board(7101271-1).\n2.開機測試問題仍在。\n3.Test ADC board的信號NORM,L與R三點的CPM,都在30萬左右（Unquenched STD).\n4.Sampler Changer需開機數次才能正常工作。\n5.上列問題將一併與原廠討論後再來處理。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "4/19-4/20維修",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-04-19 09:20:17",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "林昌盛",
							"location": "2號機",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "待確認",
							"message": "",
							"company_sname": "",
							"repair_hours": "3",
							"review_status_id": "0",
							"repair_source_id": "000775",
							"repair_count": "1",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1091",
							"status": "4",
							"repair_id": "000898-1",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "8,42",
							"start_date": "2021-04-14 08:50:06",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "2",
							"repair_discuss_count": "0",
							"request_date": "2021-04-06 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "1617",
							"company_name": "國立中興大學 生命科學系",
							"contact_id": "19202",
							"contact_name": "陳全木 老師/陳昱璇 小姐",
							"department": "",
							"work_phone": "04-2284-0319#702",
							"cell_phone": "",
							"email": "water5657@hotmail.com",
							"address": "402 台中市南區興大路145號",
							"customer_id": "EAF00B02",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Spectrum CT",
							"shipping_record_id": "",
							"serial_number": "IS1239N6062",
							"machine_model": "IVIS Spectrum CT",
							"issue_type": "",
							"issue_description": "PC 系統重整",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-04-14 11:30:06",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.換上new HDD(1TG),做兩個partitions (C:/與G:/IVIS    \n    DATD).\n2.系統restore to C:/試開機成功。\n3.先暫以此單一硬碟做資料儲存，以確定是否為原兩組\n    硬碟的問題 。\n4.待一個月的測試。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告與照片寄給陳昱璇",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-04-15 13:21:08",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳全木",
							"location": "應用科科技大樓10樓1014室",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "",
							"cost_type": "待確認",
							"message": "",
							"company_sname": "",
							"repair_hours": "3",
							"review_status_id": "0",
							"repair_source_id": "000898",
							"repair_count": "1",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1322",
							"status": "2",
							"repair_id": "001197",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "6",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "26",
							"start_date": "2021-05-24 09:30:23",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "0",
							"repair_discuss_count": "0",
							"request_date": "2021-05-13 00:00:00",
							"request_user_id": "26",
							"request_user_name": "蕭惠中",
							"company_id": "585264",
							"company_name": "APRINOIA Therapeutics Limited",
							"contact_id": "33185",
							"contact_name": "利宗霖 先生",
							"department": "",
							"work_phone": "02-26558868#20",
							"cell_phone": "",
							"email": "johnnyli@aprinoia.com",
							"address": "",
							"customer_id": "ZBA00A83-1",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "JANUS G3",
							"shipping_record_id": "",
							"serial_number": "JA1731N2096",
							"machine_model": "YJS8001",
							"issue_type": "",
							"issue_description": "JANUS又壞了",
							"fix_user_id": "28",
							"fix_user_name": "吳志岳",
							"repair_date": "",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-18 16:20:23",
							"leave_time": "",
							"create_user": "蕭惠中",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-24 06:26:50",
							"repair_department": "Service",
							"repair_priority": "急件",
							"company_owner": "張明奎",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "客戶說應該跟上次一樣X軸的問題",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1343",
							"status": "4",
							"repair_id": "000981-3",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "50",
							"start_date": "2021-05-18 11:20:01",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-18 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "3239",
							"company_name": "長庚醫療財團法人 高雄長庚紀念醫院 核子醫學科",
							"contact_id": "24736",
							"contact_name": "陳鐵祥 先生",
							"department": "",
							"work_phone": "07-7317123#3007",
							"cell_phone": "",
							"email": "m12062@adm.cgmh.org.tw",
							"address": "83301高雄市鳥松區大埤路123號",
							"customer_id": "HAL15U01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "Wizard2 Series",
							"shipping_record_id": "",
							"serial_number": "SGWZ14150261",
							"machine_model": "2470-0200",
							"issue_type": "",
							"issue_description": "Fail to initialize database connection.",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-18 16:10:48",
							"content": "",
							"job_title": "儀器課",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.更換PC unit，重整database ok.\n2.完成I-125的normalization與BKG test.\n3.機器已回復正常。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告寄陳鐵祥",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-18 14:37:04",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "陳窗達 先生",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "待確認",
							"message": "",
							"company_sname": "",
							"repair_hours": "3",
							"review_status_id": "0",
							"repair_source_id": "000981",
							"repair_count": "3",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "7600156",
									"part_name": "COMPUTER MODULE ASSEMBLY",
									"amount": "1",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1339",
							"status": "4",
							"repair_id": "001212",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-18 11:30:55",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-17 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "3873",
							"company_name": "博克科技股份有限公司",
							"contact_id": "27182",
							"contact_name": "葉恭誌",
							"department": "",
							"work_phone": "0961-094-117",
							"cell_phone": "",
							"email": "",
							"address": "臺北市新湖二路162號4樓之1",
							"customer_id": "ZZZ",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "gentleMACS",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "中山醫學大學附設醫院 /蘇先生 0911-662-209 詢問gentleMACS",
							"fix_user_id": "42",
							"fix_user_name": "葉恭誌",
							"repair_date": "2021-05-18 11:30:00",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "已回電",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-18 14:54:55",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "蔡錦承",
							"location": "",
							"brand": "Miltenyi Biotec",
							"product_line": "Miltenyi",
							"problem": "-客戶跟別家買kit，但借用的儀器暫時被搬回，想跟我們借用儀器。\n-回覆目前儀器租借給其它客戶，且會以有購買kit的客戶先租借。\n-在報儀器租用的價格方案（含購買kit的方案）",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1173",
							"status": "4",
							"repair_id": "001061",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "7",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "27,26",
							"start_date": "2021-05-17 09:00:51",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-21 00:00:00",
							"request_user_id": "34",
							"request_user_name": "李欣儒",
							"company_id": "320",
							"company_name": "衛生福利部國家中醫藥研究所",
							"contact_id": "27437",
							"contact_name": "魏紋祈 老師/陳怡如 小姐",
							"department": "",
							"work_phone": "02-28201999",
							"cell_phone": "",
							"email": "starsix18@nricm.edu.tw",
							"address": "臺北市北投區立農街二段155-1號",
							"customer_id": "BBA00A10",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "IVIS Lumina Series",
							"shipping_record_id": "",
							"serial_number": "IS1917N7662",
							"machine_model": "IVIS Lumina LT",
							"issue_type": "",
							"issue_description": "保固保養：110/05（W2）",
							"fix_user_id": "48",
							"fix_user_name": "黃啟璐",
							"repair_date": "2021-05-18 16:30:26",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.儀器內、外部清潔完成。\n2.依照Check List 完成保養、校正及確效。\n3.Test run ok。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "2-2（保固至110/8/11）Report 給聯絡人。#3551",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "李欣儒",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "魏紋祈 老師",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer invivo",
							"problem": "",
							"repair_result": "Ok",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1341",
							"status": "4",
							"repair_id": "001214",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "2,9",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "28,50,9,39,25",
							"start_date": "2021-05-18 09:40:39",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-18 00:00:00",
							"request_user_id": "39",
							"request_user_name": "鄭進展",
							"company_id": "3220",
							"company_name": "長庚醫療財團法人 高雄長庚紀念醫院 轉譯醫學所",
							"contact_id": "24664",
							"contact_name": "中野敏明 老師/賴佳筠 小姐",
							"department": "",
							"work_phone": "07-7317123#8194",
							"cell_phone": "",
							"email": "may0313@seed.net.tw",
							"address": "高雄市鳥松區大埤路123號",
							"customer_id": "HAL15N03",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "JANUS",
							"shipping_record_id": "",
							"serial_number": "DG11107044",
							"machine_model": "AJS4001",
							"issue_type": "",
							"issue_description": "Unpacking to install",
							"fix_user_id": "39",
							"fix_user_name": "鄭進展",
							"repair_date": "2021-05-18 11:10:39",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "1.完成拆箱、定位並連接pc。\n2.開機測試儀器，完成initializ。\n3.Pass to run Flush/Wash後，Empty liquid container.\n4.儀器功能正常，完成安裝測試。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "報告寄賴佳筠",
							"arrival_time": "2021-05-18 10:50:39",
							"leave_time": "",
							"create_user": "鄭進展",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "2021-05-18 10:58:32",
							"repair_department": "Service",
							"repair_priority": "普通件",
							"company_owner": "中野敏明 老師",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "",
							"cost_type": "N",
							"message": "",
							"company_sname": "",
							"repair_hours": "2",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "690",
							"status": "4",
							"repair_id": "000637",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-18 10:00:59",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-01-20 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "3873",
							"company_name": "博克科技股份有限公司",
							"contact_id": "27178",
							"contact_name": "陳俊宇",
							"department": "",
							"work_phone": "0988-691-011",
							"cell_phone": "",
							"email": "",
							"address": "臺北市新湖二路162號4樓之1",
							"customer_id": "ZZZ",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "歐易公司/賴小姐 來電詢問出給P2實驗室的PS-2000規格",
							"fix_user_id": "25",
							"fix_user_name": "陳俊宇",
							"repair_date": "2021-05-18 10:20:59",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-18 10:00:59",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "蔡錦承",
							"location": "",
							"brand": "KURABO",
							"product_line": "KURABO",
							"problem": "聯絡人：賴小姐 02-55576888",
							"repair_result": "後續直接與國家生技園區P2P3實驗室客戶劉玟君博士討論",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1139",
							"status": "4",
							"repair_id": "001028",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-18 10:00:20",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-19 00:00:00",
							"request_user_id": "32",
							"request_user_name": "黃詩蘋",
							"company_id": "539",
							"company_name": "行政院原子能委員會核能研究所 保健物理組",
							"contact_id": "15661",
							"contact_name": "蔡惠雯 小姐",
							"department": "",
							"work_phone": "03-4711400#7970",
							"cell_phone": "",
							"email": "hwtsai@iner.gov.tw",
							"address": "桃園市龍潭區佳安里文化路1000號",
							"customer_id": "BEA00G01",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "詢問Quantulus 1220 價格規格",
							"fix_user_id": "25",
							"fix_user_name": "陳俊宇",
							"repair_date": "2021-05-18 10:20:20",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-18 10:00:20",
							"leave_time": "",
							"create_user": "黃詩蘋",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "急件",
							"company_owner": "蔡惠雯",
							"location": "",
							"brand": "PerkinElmer",
							"product_line": "PerkinElmer",
							"problem": "",
							"repair_result": "後續Alex追蹤LSC及Oxidizer需求",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1152",
							"status": "4",
							"repair_id": "001040",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "27",
							"start_date": "2021-05-18 10:00:00",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-04-20 00:00:00",
							"request_user_id": "6",
							"request_user_name": "黃韻璇",
							"company_id": "2103",
							"company_name": "慈濟大學 分子生物暨人類遺傳學系",
							"contact_id": "20708",
							"contact_name": "張新侯 老師",
							"department": "",
							"work_phone": "038-565301#2681",
							"cell_phone": "",
							"email": "hhchang@mail.tcu.edu.tw",
							"address": "花蓮市中央路三段701號",
							"customer_id": "EAO00C03",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "",
							"issue_type": "",
							"issue_description": "洪先生03-8565301#2669詢價130-049-601  CD11b mb,human,mouse $25812",
							"fix_user_id": "25",
							"fix_user_name": "陳俊宇",
							"repair_date": "2021-05-18 10:00:00",
							"content": "",
							"job_title": "President",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "2021-05-18 10:00:00",
							"leave_time": "",
							"create_user": "黃韻璇",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "張新侯",
							"location": "",
							"brand": "",
							"product_line": "",
							"problem": "",
							"repair_result": "訂購完成，貨已寄出",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						},
						{
							"id": "1320",
							"status": "3",
							"repair_id": "001196",
							"type_id": "0",
							"job_number": "",
							"area_type_id": "0",
							"warranty_type_id": "0",
							"factory_id": "0",
							"factory_name": "",
							"from_id": "0",
							"shpping_description": "",
							"service_type_id": "1",
							"judge_id": "0",
							"part_id": "0",
							"teamworker": "",
							"start_date": "2021-05-13 12:10:28",
							"work_cost": "0",
							"tech_cost": "0",
							"shipping_rate": "0",
							"sub_total_cost": "0",
							"tax": "0",
							"total_cost": "0",
							"currency": "",
							"invoice_number": "",
							"invoice_title": "",
							"satisfaction_id": "1",
							"repair_discuss_count": "0",
							"request_date": "2021-05-13 00:00:00",
							"request_user_id": "38",
							"request_user_name": "高一心",
							"company_id": "3873",
							"company_name": "博克科技股份有限公司",
							"contact_id": "27180",
							"contact_name": "王博立",
							"department": "",
							"work_phone": "0978-100-367",
							"cell_phone": "",
							"email": "",
							"address": "臺北市新湖二路162號4樓之1",
							"customer_id": "ZZZ",
							"product_type_id": "",
							"product_type": "",
							"model_id": "0",
							"model_name": "",
							"shipping_record_id": "",
							"serial_number": "0",
							"machine_model": "NanoDrop 2000",
							"issue_type": "",
							"issue_description": "ND2000 同行詢價 （海力克）",
							"fix_user_id": "49",
							"fix_user_name": "王博立",
							"repair_date": "2021-05-13 12:20:29",
							"content": "",
							"job_title": "",
							"shipping_date": "",
							"warranty_expire_date": "",
							"solution_description": "聯繫曾先生，確認end user是台大徐丞志老師，再給估價單。",
							"replacement_parts": "",
							"return_status": "",
							"discount": "0",
							"price": "0",
							"signature": "",
							"source": "ServiceSky",
							"remark": "",
							"arrival_time": "",
							"leave_time": "",
							"create_user": "高一心",
							"used_status": "",
							"ext_number": "0",
							"supervisor_review": "",
							"expect_date": "",
							"repair_department": "Sales",
							"repair_priority": "普通件",
							"company_owner": "蔡錦承",
							"location": "",
							"brand": "Thermo Scientific",
							"product_line": "Thermo",
							"problem": "海力克(同行）曾先生(Andy) 0919-816-238\n來電想詢價ND2000，透露End User是台大化學系，是統包案\n\n麻煩請回電處理，謝謝",
							"repair_result": "",
							"cost_type": "",
							"message": "",
							"company_sname": "",
							"repair_hours": "0",
							"review_status_id": "0",
							"repair_source_id": "",
							"repair_count": "0",
							"next_doc_id_list": "",
							"parts_list": [
								{
									"part_id": "",
									"part_name": "",
									"amount": "0",
									"unit_price": "0",
									"subtotal": "0",
									"part_spec": "",
									"remark": ""
								}
							],
							"before_doc_id_list": "",
							"can_update": "1",
							"can_delete": "1"
						}
					];
				} else {
					data = res.status === '0' ? res.result : [];
					total_count = res.total_count * 1;
				}

				let all_data = _.orderBy(data, ['repair_id'], ['desc']);	//簡易過濾

				// 討論筆數轉數字
				for (let i = all_data.length - 1; i >= 0; i--) {
					all_data[i].repair_discuss_count = parseInt(all_data[i].repair_discuss_count, 10);
				}

				this.setState({ all_data, is_all_data_loaded: true, start_count, total_count });
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}

	reload(routeType) {
		this.setState({ is_all_data_loaded: false, is_merge: false }, () => {
			this.loadTableData()
		})

		if (routeType === 'add') {
			// 新增項目時增加對應的勾選格
			if (this.state.arrIsCheck) {
				const arrIsCheck = this.state.arrIsCheck.slice();
				arrIsCheck.unshift(false);
				this.setState({ arrIsCheck });
			}
		}
	}

	loadOtherData(url, dataType, is_loaded) {
		const { languageData, languageCode } = window.myConsts;
		// let test = '';
		// if(is_loaded === 'is_parts_data_loaded') {
		//   test+= '&start_count=1';
		//   test+= '&end_count=140000'; // 15萬api就掛點
		// }

		$.ajax({
			type: 'get',
			url: `${url}?lang_code=${languageCode}`, // + test,
			success: res => {
				if (res.status === '0') {
					let result_data = [];
					if (res.result === 'no data found!') {
						result_data = [];
					} else {
						result_data =
							res.result.length === 0 ?
								[
									{ id: '1', name: '測試選項一' },
									{ id: '2', name: '測試選項二' },
									{ id: '3', name: '測試選項三' }
								]
								: res.result
					}

					let new_data = [];
					switch (dataType) {
						case 'company_data':
							new_data =
								result_data.map((x, y) => {
									return {
										id: x.id,
										name: x.name,
										address: x.address.street
									}
								});

							result_data = new_data;
							break;
						case 'brand_data':
							new_data =
								result_data.map((x, y) => {
									return {
										id: x.brand_id,
										name: x.brand_name,
										...x
									}
								});

							result_data = new_data;
							break;
						case 'service_result_data':
							new_data =
								result_data.map((x, y) => {
									return {
										id: x.satisfaction_id,
										name: x.satisfaction_name,
										...x
									}
								});

							result_data = new_data;
							break;
						case 'basic_data':
							new_data =
								result_data.map((x, y) => {
									return {
										name: x.value,
										...x
									}
								});

							result_data = new_data;
							break;

						default:
					}

					let obj = {};
					obj[dataType] = result_data;
					obj[is_loaded] = true;
					this.setState(obj);
				}
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}

	onRowClick(row, event, rowIndex) {
		// 檢查匯出pdf tooltip是否已存在，若是則關閉
		if ($('#popover-trigger-click')[0]) {
			$('#btnPDFBatchExport').click();
		}

		// 判斷是否來自客戶tab
		if (this.props.onTabTableRowClick) {
			// 單純用來產生modal
			this.props.onTabTableRowClick(row.id);
		} else {
			this.props.routeHandler(`/salesky/online-repair-service/${row.id}`);
		}

		this.setState({
			selectedRowIndex: rowIndex,
			selectedItemId: row.id
		});
	}

	onDateChange(type, date) {
		type === 'start_date' ? this.setState({ start_date: date }) : this.setState({ end_date: date })
	}

	onSortChange(sort_name) {
		const { all_data, table_sort } = this.state;
		let sort = table_sort.sort === 'asc' ? 'desc' : 'asc';

		// 非點擊header主動排序時，代表是復原排序
		if (sort_name === undefined) {
			sort_name = table_sort.name;
			sort = table_sort.sort;
		}

		let sort_data = _.orderBy(all_data, [sort_name], sort)
		this.setState({ table_sort: { name: sort_name, sort: sort }, all_data: sort_data })
	}

	filterOptions(optsObjArr, stringFilter, selectedOptions) {
		const vaildOptions = _.difference(optsObjArr, selectedOptions);
		// 轉小寫的選項arr應該以state存起來避免每次重運算，只在opts更新時做更新
		// 如果運算loading相對小，不儲存可以節省記憶體，依情境取捨
		let filteredOptsObjArr = [];
		if (stringFilter) {
			let stringFilterLowerCase = stringFilter.toLowerCase();

			_.forEach(vaildOptions, (val, key) => {
				if (
					(
						val.name &&
						val.name.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					) ||
					(
						val.label &&
						val.label.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					)
				) {
					filteredOptsObjArr.push(val);
				}
			});
		} else {
			filteredOptsObjArr = vaildOptions;
		}

		return filteredOptsObjArr;
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const props = this.props, state = this.state,
			{ userId, oldFuncExtraProps } = props,
			{ showBatchExportUI } = oldFuncExtraProps,
			{
				is_loading,
				all_data,
				start_date,
				end_date,
				width,
				status_data,
				is_status_data_loaded,
				user_data,
				is_user_data_loaded,
				// form_type_data,
				// is_form_type_data_loaded,
				area_data,
				is_area_data_loaded,
				// contract_data,
				// is_contract_data_loaded,
				company_data,
				is_company_data_loaded,
				factory_data,
				is_factory_data_loaded,
				// form_source_data,
				// is_form_source_data_loaded,
				repair_man_data,
				is_man_data_loaded,
				// product_data,
				// is_product_data_loaded,
				// service_type_data,
				// is_service_type_data_loaded,
				assign_data,
				is_assign_data_loaded,
				// question_data,
				// is_question_data_loaded,
				// responsibility_data,
				// is_responsibility_data_loaded,
				parts_data,
				is_parts_data_loaded,
				// currency_data,
				// is_currency_data_loaded,
				service_result_data,
				is_service_result_data_loaded,
				basic_data,
				is_basic_data_loaded,
				brand_data,
				is_brand_data_loaded,
				table_sort,
				arrIsCheck,
				arrCheckedId,
				onExportPDF
			} = state;

		let
			filter_data = all_data,
			modal =
				props.children ?
					React.cloneElement(props.children, {
						costViewPermission: props.oldFuncExtraProps.costViewPermission,
						userPermission: props.userPermission,
						arrIsCheck,
						arrCheckedId,
						selectedRowIndex: state.selectedRowIndex,
						selectedItemId: state.selectedItemId,
						company_id: props.company_id,
						parentStateHandler: this.parentStateHandler,
						user_id: userId,
						user_name: props.userName,
						closeModal: this.handlers.onCloseModal,
						reload: this.reload,
						filter_data,
						status_data,
						user_data,
						// form_type_data,
						area_data,
						// contract_data,
						company_data,
						factory_data,
						// form_source_data,
						repair_man_data,
						// product_data,
						// service_type_data,
						assign_data,
						// question_data,
						// responsibility_data,
						// parts_data,
						// currency_data,
						service_result_data,
						basic_data,
						brand_data,
						is_brand_data_loaded,
						is_basic_data_loaded,
						is_user_data_loaded,
						is_status_data_loaded,
						// is_form_type_data_loaded,
						is_area_data_loaded,
						// is_contract_data_loaded,
						is_company_data_loaded,
						is_factory_data_loaded,
						// is_form_source_data_loaded,
						// is_product_data_loaded,
						is_man_data_loaded,
						// is_service_type_data_loaded,
						is_assign_data_loaded,
						// is_question_data_loaded,
						// is_responsibility_data_loaded,
						// is_parts_data_loaded,
						// is_currency_data_loaded,
						is_service_result_data_loaded,
					})
					: '';

		const
			sortedCol = state.table_sort.name,
			sortDir = state.table_sort.sort,
			rowsCount = filter_data.length,
			exportBtnDisable = arrIsCheck ? (arrIsCheck.indexOf(true) === -1 ? true : false) : true,
			btnExportPDF = <DeleteBtnWithConfirm
				disabled={exportBtnDisable}
				id='btnPDFBatchExport'
				btnTitle={onExportPDF ? '匯出中…' : languageData['473'][languageCode]}
				title={languageData['411'][languageCode]}
				style={{
					position: 'relative', zIndex: '3', height: 24,
					// lineHeight: '24px',
					fontSize: 16,
					padding: '0px 5px'
				}}
				// placement='top'
				onClick={() => { this.onExportClick(true) }}
				onCancelClick={() => { this.onExportClick(false) }} />;

		// 效能改善，此處在每次 render 都處理其實不好，有空優化
		let sortIndexs = [];
		const len = filter_data.length;
		for (let i = 0; i < len; i++) {
			sortIndexs.push(i);
		}

		const discussData = new DataListWrapper(sortIndexs, filter_data);

		return (
			<div id='div-work-log-table-container' style={{ position: 'relative' }}>
				{/* <ExportBtn onClick={this.onClickExport} /> */}
				<Uploading ref='uploading' isShow={is_loading} />

				<Table
					rowHeight={50}
					headerHeight={50}
					rowsCount={rowsCount}
					width={props.tabWidth || ((props.isBigSideBar ? 0 : 186) + props.workLogProps.tableWidth)}
					height={props.tabHeight || (props.tableHeight || 477)}
					onScrollEnd={(x, y) => { this.handlers.onTableScroll(x, y) }}
					onRowClick={(event, rowIndex) => this.onRowClick(filter_data[rowIndex], event, rowIndex)}
				// {...props}
				>
					{
						showBatchExportUI ?
							<Column
								width={100}
								flexGrow={0}
								cell={({ rowIndex, ...props }) => (
									<Cell {...props} onClick={(e) => { this.onExportChecked(e, rowIndex) }}>
										<Glyphicon glyph={arrIsCheck ? (arrIsCheck[rowIndex] ? 'check' : 'unchecked') : 'unchecked'}
											style={{
												color: '#767676',
												width: '100%',
												height: '100%',
												textAlign: 'center',
												fontSize: 28,
												paddingRight: 0
											}} />

									</Cell>
								)}
								header={
									<Cell style={{ textAlign: 'center' }}>
										{btnExportPDF}
									</Cell>
								}
							/>
							: null
					}

					<Column
						columnKey='repair_discuss_count'
						header={
							<SortHeaderCell
								onSortChange={() => this.onSortChange('repair_discuss_count')}
								sortDir={sortedCol === 'repair_discuss_count' ? sortDir.toUpperCase() : null}>
								{languageData['454'][languageCode]}
							</SortHeaderCell>
						}
						cell={
							<DiscussionCell sortedData={discussData}
								onClick={this.handlers.onDiscussionsClick}
								style={{ textAlign: 'center' }}
								className='worklog-discussion-cell' />
						}
						flexGrow={0}
						width={80}
					/>
					<Column
						width={100}
						flexGrow={1}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								<div>{filter_data[rowIndex]['repair_id']}</div>
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('repair_id')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'維修單編號'} {sortedCol === 'repair_id' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={120}
						flexGrow={1}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								<div style={{ padding: '7px 0', height: 34 }}>
									<span style={{
										backgroundColor: filter_data[rowIndex]['status_color'],
										backgroundImage: 'url(/imgs/ic_state_dot.svg)',
										backgroundPosition: 'center',
										backgroundRepeat: 'no-repeat',
										backgroundSize: 'contain',
										borderRadius: '50%',
										width: 20,
										height: 20,
										float: 'left',
										marginRight: 5
									}}>
									</span>

									<span style={{ float: 'left', color: filter_data[rowIndex]['color_code'] }}>
										{filter_data[rowIndex]['status_name']}
									</span>
								</div>
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('status_name')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'狀態'} {sortedCol === 'status_name' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={100}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['request_date'] ? Moment(filter_data[rowIndex]['request_date']).format('YYYY-MM-DD') : ''}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('request_date')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'填單日期'} {sortedCol === 'request_date' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={120}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['fix_user_name']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('fix_user_name')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'負責工程師'} {sortedCol === 'fix_user_name' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={250}
						flexGrow={3}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['company_name']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('company_name')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'客戶全稱'} {sortedCol === 'company_name' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={120}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['model_name']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('model_name')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'儀器名稱'} {sortedCol === 'model_name' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={120}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['serial_number']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('serial_number')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'儀器序號'} {sortedCol === 'serial_number' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={250}
						flexGrow={5}
						cell={({ rowIndex, ...props }) => {
							let description = filter_data[rowIndex]['issue_description']

							if (description.length >= 30) {
								description = description.substr(0, 30) + '...'
							}

							return (
								<Cell {...props}>
									{description}
								</Cell>
							)
						}}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('issue_description')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'叫修內容 (概要)'} {sortedCol === 'issue_description' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={100}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['create_user']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('create_user')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'申請人'} {sortedCol === 'create_user' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
					<Column
						width={100}
						flexGrow={2}
						cell={({ rowIndex, ...props }) => (
							<Cell {...props}>
								{filter_data[rowIndex]['area_type_name']}
							</Cell>
						)}
						header={
							<Cell>
								<a onClick={() => this.onSortChange('area_type_name')}
									style={{ textDecoration: 'none', cursor: 'pointer' }}>
									{'區域'} {sortedCol === 'area_type_name' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
								</a>
							</Cell>
						}
					/>
				</Table>
				{/* {modal} */}
				{/* 廠區資料載入後才可顯示modal */}
				{is_factory_data_loaded ? modal : null}

				{
					state.showDiscussionModal ?
						<DiscussionModal
							type='repair'
							show={state.showDiscussionModal}
							closeModal={this.closeDiscussionModal}
							itemId={state.selectedItemId}
							rowIndex={state.selectedRowIndex}
							sortedData={discussData} />
						: ''
				}
				{
					state.showCloudSearchModal ?
						<CloudSearchModalUd
							origProps={this.props}
							origState={this.state}
							onGoSearch={(str) => { this.handlers.onChangeCloudSearch('search', str) }}
							onChangeData={(data) => { this.handlers.onChangeCloudSearch('change', data) }}
							closeModal={() => { this.handlers.onChangeCloudSearch('close') }}
							filterOptions={this.filterOptions}
						/>
						: ''
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/online_repair/OnlineRepairServiceDataTable.jsx